const response = {
  risk_in: {
    ubication: {
      address_line1: "",
      postal_code: "05001",
      place: {
        city_code: "001",
        city_name: "MEDELLÍN",
        state_code: "05",
        state_name: "Antioquia",
        country_code: "49",
        country_name: "Colombia",
      },
    },
    id_db: 12277,
    category: "particulares",
    last_update: "2025-10-09 19:31:53.109",
    business_line: "vehiculos",
    parties: [
      {
        party_rol: "Asegurado",
        party_type: "person",
        person: {
          birht_date: "2000-03-12",
          age: 25,
          contact_data: [
            {
              contact_info: {
                email: "cristian.munoz@agentemotor.com",
                phone: "3112499796",
                ubication: {
                  address_line1: "Calle 1",
                  place: {
                    city_code: "001",
                    city_name: "MEDELLÍN",
                    country_code: "49",
                    country_name: "Colombia",
                    state_code: "05",
                    state_name: "Antioquia",
                  },
                  postal_code: "05001",
                },
                phone_prefix: "+57",
              },
              contact_tag: "Email",
            },
          ],
          educational_level: "primary",
          firstname: "Cristian Daniel",
          gender: "M",
          identification_number: "1003813097",
          identification_type: "CC",
          lastname: "Munoz Quintero",
          id_expedition_date: "2018-04-23",
          logs_terms_and_policy: [
            {
              date: "2025-10-09T17:45:51.475Z",
              event: "terms",
              ip: "180.254.227.216",
              link: "https://www.siempremarsh.com/pe/es/terms-of-use.html",
              origin: "Formulario Asesor",
              name: "Cristian Daniel Munoz Quintero",
              identification_number: "1003813097",
              identification_type: "CC",
              email: "cristian.munoz@agentemotor.com",
              phone: "3112499796",
            },
            {
              date: "2025-10-09T17:45:51.475Z",
              event: "politics",
              ip: "180.254.227.216",
              link: "https://www.marsh.com/co/privacy-notice.html#:~:text=Aviso",
              origin: "Formulario Asesor",
              name: "Cristian Daniel Munoz Quintero",
              identification_number: "1003813097",
              identification_type: "CC",
              email: "cristian.munoz@agentemotor.com",
              phone: "3112499796",
            },
          ],
          economic_activity_details: {
            description: "Edición de programas de informática (software)",
            code: "5820",
          },
          economic_activity: "5820",
          occupation: "25120",
          profession_details: {
            description: "Desarrolladores de software",
            code: "25120",
          },
          profession: "25120",
          sarlaft_data: {
            monthly_income: 2300000,
            monthly_expenses: 1500000,
            total_assets: 20000000,
            total_liabilities: 20000,
            shareholder_identification_type: {
              text: "Cédula de Ciudadanía",
              id: "CC",
            },
            shareholder_identification_number: "1003813097",
            shareholder_business_name: " ",
            update_date: "2025-10-09",
          },
          marital_status: false,
        },
      },
    ],
    insurable_objects: [
      {
        vehicle: {
          brand: "KIA",
          codification: {
            code: "04606152",
            fuel: "*",
            nationality: "",
          },
          cylinder: "1999",
          line: "SPORTAGE [5]-NQ5 ZENITH-TP 2000CC 6AB ABS TC CT 4X2",
          model: "2024",
          number_passengers: "5",
          plate: "LYW119",
          type: "CAMIONETA PASAJ.",
          vehicle_risk: {
            protection_type: "ninguno",
            accesories_price: "0",
            in_agency: false,
            plate_type: "particular",
            reference_price: 127400000,
            commercial_price: 127400000,
            use_type: "particular",
            use_time: 1,
          },
          weight: 0,
          accessories: [],
          engine_number: "",
          chassis_number: "",
          vin: "",
        },
        type: "vehicle",
        price_sugested: 127400000,
        identification: "LYW119-KIA-SPORTAGE",
        description:
          '\n      <span style="padding-left: 0px; display: flex; flex-wrap: wrap;">\n      <span style="margin-right:5px">\n          <span>\n          <strong>Placa: </strong>\n          </span>\n          <span>\n          <span>LYW119</span>\n          </span>\n      </span>\n      <span style="margin-right:5px">\n          <span>\n          <strong>Vehículo: </strong>\n          </span>\n          <span>\n          <span>CAMIONETA PASAJ. KIA SPORTAGE [5]-NQ5 ZENITH-TP 2000CC 6AB ABS TC CT 4X2</span>\n          </span>\n      </span>\n      <span style="margin-right:5px">\n          <span>\n          <strong>0 Kilometros: </strong>\n          </span>\n          <span>\n          <span>No</span>\n          </span>\n      </span>\n      <span style="margin-right:5px">\n          <span>\n          <strong>Modelo: </strong>\n          </span>\n          <span>\n          <span>2024</span>\n          </span>\n      </span>\n      <span style="margin-right:5px">\n          <span>\n          <strong>Uso: </strong>\n          </span>\n          <span>\n          <span>particular</span>\n          </span>\n      </span>\n      <span style="margin-right:5px">\n          <span>\n          <strong>Cod Fasecolda: </strong>\n          </span>\n          <span>04606152</span>\n      </span>\n      <span style="margin-right:5px">\n          <span>\n          <strong>Val Fasecolda: </strong>\n          </span>\n          <span>\n          <span>$127,400,000</span>\n          </span>\n      </span>\n      <span style="margin-right:5px">\n          <span>\n          <strong>Val Solicitado: </strong>\n          </span>\n          <span>\n          <span>$127,400,000</span>\n          </span>\n      </span>\n      <span style="margin-right:5px">\n          <span>\n          <strong>Val Accesorios: </strong>\n          </span>\n          <span>$0</span>\n      </span>\n      </span>\n      ',
        tag: "LYW119",
      },
    ],
  },
  policy_list: [
    {
      id_db: 25218,
      process_id: "25520859",
      duration_days: "365",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/Allianz_Individual-LYW119-25520859.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "allianz_ws",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: false,
      process_comments: [""],
      product_type: "individual",
      score: 60,
      provider: null,
      total_price: 8866134,
      total_price_anual: 8866134,
      price_type: "anual",
      total_price_month: 0,
      products: [
        {
          price: 8866134,
          name: "Allianz - Autos Plus",
          description:
            "Allianz - Autos Plus\n\nPequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.): 1 SMMLV  2 eventos por vigencia\nLlantas estalladas: 1,5 SMMLV 1 evento por vigencia\nRotura de vidrios: 1,5 SMMLV 1 evento por vigencia\nPérdida de llaves: 1,5 SMMLV 1 evento por vigencia\nAsistencias Gold: Si Cubre\nResponsabilidad Civil Extracontractual (Limite global): $5.000.000.000\nDeducible Pérdida Total Daños: Sin Deducible\nDeducible Pérdida Parcial Daños: Deducible Único: 1.0 SMMLV\nDeducible Pérdida Total Hurto: Sin Deducible\nDeducible Pérdida Parcial Hurto: Deducible Único: 1.0 SMMLV\nDeducible ante eventos de la naturaleza como temblor, terremoto: Deducible Único: 1.0 SMMLV\nVehículo de reemplazo ante Pérdidas Totales: SI\nAccidentes personales en accidentes de tránsito: 50000000.00\nServicio de grúa en caso de accidente o varada: SI\nConductor elegido: SI\nOtros Valores Agregados: Emergencias en Carretera\nAsistencia en Viaje: Plus\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/allianz.jpg",
          manufacturer: "Allianz",
          coverages: [
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "50000000.00",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Plus",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$5.000.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "1200000",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(38)",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sin Deducible",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "catalog(38)",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1.0 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 200,
              coverage_tag: "VEHRPT",
              description_tag: "Vehículo de reemplazo ante Pérdidas Totales",
              is_product_tag: false,
              priority: 3,
              group_id: 30,
              tag_group: "VEHRPT",
              action_tag: "R",
              view_status: "2",
              description: "SI",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 206,
              coverage_tag: "VEHRPP",
              description_tag: "Vehículo de reemplazo ante Pérdidas Parciales",
              is_product_tag: false,
              priority: 4,
              group_id: 30,
              tag_group: "VEHRPP",
              action_tag: "R",
              view_status: "1",
              description: "Hasta 15 días",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(38)",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1.0 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(38)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1.0 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "$50.000.000",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(38)",
            },
            {
              attribute_id: 236,
              coverage_tag: "CUBREP",
              description_tag: "Reposición del vehículo por pérdida total",
              is_product_tag: false,
              priority: 20,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(38)",
            },
            {
              attribute_id: 346,
              coverage_tag: "CONMED",
              description_tag: "Consulta médica domiciliaria",
              is_product_tag: true,
              priority: 3,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description:
                "Medico en casa para el asegurado y el conyugue con Copago de $30.000 por cada consulta - Sin límite de eventos",
              res: "1",
              group: "Valor Diferencial",
              source: "asists[88]",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "1,5 SMMLV 1 evento por vigencia",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "1,5 SMMLV 1 evento por vigencia",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "1 SMMLV  2 eventos por vigencia",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "1,5 SMMLV 1 evento por vigencia",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 1002,
              coverage_tag: "URLCLA",
              description_tag: "Url Clausulado Aseguradoras",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "https://l.agentemotor.com/85uci4a",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(38)",
            },
            {
              attribute_id: 1157,
              coverage_tag: "ASIGOL",
              description_tag: "Asistencias Gold",
              is_product_tag: false,
              priority: 3,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 208,
              coverage_tag: "CONELG",
              description_tag: "Conductor elegido",
              is_product_tag: false,
              priority: 3,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "2",
              description: "SI",
              res: "1",
              group: "Asistencias al vehículo",
              source: "quotation",
            },
            {
              attribute_id: 368,
              coverage_tag: "SERGRD",
              description_tag: "Servicio de grúa en caso de avería",
              is_product_tag: false,
              priority: 11,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "$950.000 por evento - Hasta 4 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 369,
              coverage_tag: "SERGRU",
              description_tag: "Servicio de grúa en caso de accidente o varada",
              is_product_tag: false,
              priority: 4,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "SI",
              res: "1",
              group: "Asistencias al vehículo",
              source: "quotation",
            },
            {
              attribute_id: 374,
              coverage_tag: "INFTRE",
              description_tag: "Revisión antes de viaje",
              is_product_tag: false,
              priority: 1,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 375,
              coverage_tag: "CARDES",
              description_tag:
                "Servicio de carro taller (Pinchazo, varada por gasolina, cerrajería)",
              is_product_tag: false,
              priority: 2,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "$550.000 por evento - Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 378,
              coverage_tag: "DECUVE",
              description_tag:
                "Depósito o custodia del vehículo después de reparado",
              is_product_tag: false,
              priority: 8,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description:
                "$190.000 por evento - $950.000 para transporte del vehículo ",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 382,
              coverage_tag: "ASTEAC",
              description_tag:
                "Asistencia jurídica telefónica en caso de accidente",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 384,
              coverage_tag: "ASLETT",
              description_tag:
                "Asesoría legal telefónica en trámites o procedimientos de tránsito",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 235,
              coverage_tag: "OTRVAL",
              description_tag: "Otros Valores Agregados",
              is_product_tag: null,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Emergencias en Carretera",
              source: "quotation",
            },
          ],
        },
      ],
    },
    {
      id_db: 25216,
      process_id: "25520858",
      duration_days: "366",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/Allianz_Colectiva-LYW119-25520858.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "allianz_ws",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: false,
      process_comments: [""],
      product_type: "colectiva",
      score: 51,
      provider: null,
      total_price: 11178608,
      total_price_anual: 11178608,
      price_type: "anual",
      total_price_month: 1004960.41,
      products: [
        {
          price: 11178608,
          name: "Allianz - Llave en Mano - Colectiva",
          description:
            "Allianz - Llave en Mano - Colectiva\n\nResponsabilidad Civil Extracontractual (Limite global): $5.000.000.000\nDeducible Pérdida Total Daños: Sin Deducible\nDeducible Pérdida Parcial Daños: Deducible Único: 1.00 SMMLV\nDeducible Pérdida Total Hurto: Sin Deducible\nDeducible Pérdida Parcial Hurto: Deducible Único: 1.00 SMMLV\nDeducible ante eventos de la naturaleza como temblor, terremoto: Deducible Único: 1.00 SMMLV\nVehículo de reemplazo ante Pérdidas Totales: Hasta 20 días\nGastos de Transporte por Pérdidas Totales: $1.200.000\nServicio de grúa en caso de accidente o varada: Limite maximo $1.300.000 (4 traslados de un trayecto por vigencia en caso de varada, e ilimitado en caso de accidente)\nConductor elegido: 12 servicios por vigencia\nOtros Valores Agregados: Emergencias en Carretera\nAsistencia en Viaje: Plus\nPequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.): 1 SMMLV  2 eventos por vigencia\nLlantas estalladas: 1,5 SMMLV 1 evento por vigencia\nRotura de vidrios: 1,5 SMMLV 1 evento por vigencia\nPérdida de llaves: 1,5 SMMLV 1 evento por vigencia\nAsistencias Gold: Si Cubre\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/allianz.jpg",
          manufacturer: "Allianz",
          coverages: [
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "$50.000.000",
              res: "1",
              group: "Valor Diferencial",
              source: "asists[88]",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Plus",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$5.000.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "$1.200.000",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sin Deducible",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "catalog(38)",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1.00 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 200,
              coverage_tag: "VEHRPT",
              description_tag: "Vehículo de reemplazo ante Pérdidas Totales",
              is_product_tag: false,
              priority: 3,
              group_id: 30,
              tag_group: "VEHRPT",
              action_tag: "R",
              view_status: "2",
              description: "Hasta 20 días",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 206,
              coverage_tag: "VEHRPP",
              description_tag: "Vehículo de reemplazo ante Pérdidas Parciales",
              is_product_tag: false,
              priority: 4,
              group_id: 30,
              tag_group: "VEHRPP",
              action_tag: "R",
              view_status: "1",
              description: "Hasta 15 días",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(38)",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1.00 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(38)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1.00 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "$50.000.000",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(38)",
            },
            {
              attribute_id: 236,
              coverage_tag: "CUBREP",
              description_tag: "Reposición del vehículo por pérdida total",
              is_product_tag: false,
              priority: 20,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(38)",
            },
            {
              attribute_id: 346,
              coverage_tag: "CONMED",
              description_tag: "Consulta médica domiciliaria",
              is_product_tag: true,
              priority: 3,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description:
                "Medico en casa para el asegurado y el conyugue con Copago de $30.000 por cada consulta - Sin límite de eventos",
              res: "1",
              group: "Valor Diferencial",
              source: "asists[88]",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "1,5 SMMLV 1 evento por vigencia",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "1,5 SMMLV 1 evento por vigencia",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "1 SMMLV  2 eventos por vigencia",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "1,5 SMMLV 1 evento por vigencia",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 1002,
              coverage_tag: "URLCLA",
              description_tag: "Url Clausulado Aseguradoras",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "https://l.agentemotor.com/85uci4a",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(38)",
            },
            {
              attribute_id: 1157,
              coverage_tag: "ASIGOL",
              description_tag: "Asistencias Gold",
              is_product_tag: false,
              priority: 3,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 208,
              coverage_tag: "CONELG",
              description_tag: "Conductor elegido",
              is_product_tag: false,
              priority: 3,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "2",
              description: "12 servicios por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "quotation",
            },
            {
              attribute_id: 368,
              coverage_tag: "SERGRD",
              description_tag: "Servicio de grúa en caso de avería",
              is_product_tag: false,
              priority: 11,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "$950.000 por evento - Hasta 4 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 369,
              coverage_tag: "SERGRU",
              description_tag: "Servicio de grúa en caso de accidente o varada",
              is_product_tag: false,
              priority: 4,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description:
                "Limite maximo $1.300.000 (4 traslados de un trayecto por vigencia en caso de varada, e ilimitado en caso de accidente)",
              res: "1",
              group: "Asistencias al vehículo",
              source: "quotation",
            },
            {
              attribute_id: 374,
              coverage_tag: "INFTRE",
              description_tag: "Revisión antes de viaje",
              is_product_tag: false,
              priority: 1,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 375,
              coverage_tag: "CARDES",
              description_tag:
                "Servicio de carro taller (Pinchazo, varada por gasolina, cerrajería)",
              is_product_tag: false,
              priority: 2,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "$550.000 por evento - Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 378,
              coverage_tag: "DECUVE",
              description_tag:
                "Depósito o custodia del vehículo después de reparado",
              is_product_tag: false,
              priority: 8,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description:
                "$190.000 por evento - $950.000 para transporte del vehículo ",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 382,
              coverage_tag: "ASTEAC",
              description_tag:
                "Asistencia jurídica telefónica en caso de accidente",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 384,
              coverage_tag: "ASLETT",
              description_tag:
                "Asesoría legal telefónica en trámites o procedimientos de tránsito",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 235,
              coverage_tag: "OTRVAL",
              description_tag: "Otros Valores Agregados",
              is_product_tag: null,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Emergencias en Carretera",
              source: "quotation",
            },
          ],
        },
      ],
    },
    {
      id_db: 25215,
      process_id: "25520858",
      duration_days: "366",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/Allianz_Colectiva-LYW119-25520858.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "allianz_ws",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: true,
      process_comments: [""],
      product_type: "colectiva",
      score: 60,
      provider: null,
      total_price: 8866134,
      total_price_anual: 8866134,
      price_type: "anual",
      total_price_month: 797008.07,
      products: [
        {
          price: 8866134,
          name: "Allianz - Autos Plus - Colectiva",
          description:
            "Allianz - Autos Plus - Colectiva\n\nResponsabilidad Civil Extracontractual (Limite global): $5.000.000.000\nDeducible Pérdida Total Daños: Sin Deducible\nDeducible Pérdida Parcial Daños: Deducible Único: 1.00 SMMLV\nDeducible Pérdida Total Hurto: Sin Deducible\nDeducible Pérdida Parcial Hurto: Deducible Único: 1.00 SMMLV\nDeducible ante eventos de la naturaleza como temblor, terremoto: Deducible Único: 1.00 SMMLV\nVehículo de reemplazo ante Pérdidas Totales: Hasta 20 días\nGastos de Transporte por Pérdidas Totales: $1.200.000\nServicio de grúa en caso de accidente o varada: Limite maximo $1.300.000 (4 traslados de un trayecto por vigencia en caso de varada, e ilimitado en caso de accidente)\nConductor elegido: 12 servicios por vigencia\nOtros Valores Agregados: Emergencias en Carretera\nAsistencia en Viaje: Plus\nPequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.): 1 SMMLV  2 eventos por vigencia\nLlantas estalladas: 1,5 SMMLV 1 evento por vigencia\nRotura de vidrios: 1,5 SMMLV 1 evento por vigencia\nPérdida de llaves: 1,5 SMMLV 1 evento por vigencia\nAsistencias Gold: Si Cubre\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/allianz.jpg",
          manufacturer: "Allianz",
          coverages: [
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "$50.000.000",
              res: "1",
              group: "Valor Diferencial",
              source: "asists[88]",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Plus",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$5.000.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "$1.200.000",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sin Deducible",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "catalog(38)",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1.00 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 200,
              coverage_tag: "VEHRPT",
              description_tag: "Vehículo de reemplazo ante Pérdidas Totales",
              is_product_tag: false,
              priority: 3,
              group_id: 30,
              tag_group: "VEHRPT",
              action_tag: "R",
              view_status: "2",
              description: "Hasta 20 días",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 206,
              coverage_tag: "VEHRPP",
              description_tag: "Vehículo de reemplazo ante Pérdidas Parciales",
              is_product_tag: false,
              priority: 4,
              group_id: 30,
              tag_group: "VEHRPP",
              action_tag: "R",
              view_status: "1",
              description: "Hasta 15 días",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(38)",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1.00 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(38)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1.00 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "$50.000.000",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(38)",
            },
            {
              attribute_id: 236,
              coverage_tag: "CUBREP",
              description_tag: "Reposición del vehículo por pérdida total",
              is_product_tag: false,
              priority: 20,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(38)",
            },
            {
              attribute_id: 346,
              coverage_tag: "CONMED",
              description_tag: "Consulta médica domiciliaria",
              is_product_tag: true,
              priority: 3,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description:
                "Medico en casa para el asegurado y el conyugue con Copago de $30.000 por cada consulta - Sin límite de eventos",
              res: "1",
              group: "Valor Diferencial",
              source: "asists[88]",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "1,5 SMMLV 1 evento por vigencia",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "1,5 SMMLV 1 evento por vigencia",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "1 SMMLV  2 eventos por vigencia",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "1,5 SMMLV 1 evento por vigencia",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 1002,
              coverage_tag: "URLCLA",
              description_tag: "Url Clausulado Aseguradoras",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "https://l.agentemotor.com/85uci4a",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(38)",
            },
            {
              attribute_id: 1157,
              coverage_tag: "ASIGOL",
              description_tag: "Asistencias Gold",
              is_product_tag: false,
              priority: 3,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 208,
              coverage_tag: "CONELG",
              description_tag: "Conductor elegido",
              is_product_tag: false,
              priority: 3,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "2",
              description: "12 servicios por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "quotation",
            },
            {
              attribute_id: 368,
              coverage_tag: "SERGRD",
              description_tag: "Servicio de grúa en caso de avería",
              is_product_tag: false,
              priority: 11,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "$950.000 por evento - Hasta 4 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 369,
              coverage_tag: "SERGRU",
              description_tag: "Servicio de grúa en caso de accidente o varada",
              is_product_tag: false,
              priority: 4,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description:
                "Limite maximo $1.300.000 (4 traslados de un trayecto por vigencia en caso de varada, e ilimitado en caso de accidente)",
              res: "1",
              group: "Asistencias al vehículo",
              source: "quotation",
            },
            {
              attribute_id: 374,
              coverage_tag: "INFTRE",
              description_tag: "Revisión antes de viaje",
              is_product_tag: false,
              priority: 1,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 375,
              coverage_tag: "CARDES",
              description_tag:
                "Servicio de carro taller (Pinchazo, varada por gasolina, cerrajería)",
              is_product_tag: false,
              priority: 2,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "$550.000 por evento - Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 378,
              coverage_tag: "DECUVE",
              description_tag:
                "Depósito o custodia del vehículo después de reparado",
              is_product_tag: false,
              priority: 8,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description:
                "$190.000 por evento - $950.000 para transporte del vehículo ",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 382,
              coverage_tag: "ASTEAC",
              description_tag:
                "Asistencia jurídica telefónica en caso de accidente",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 384,
              coverage_tag: "ASLETT",
              description_tag:
                "Asesoría legal telefónica en trámites o procedimientos de tránsito",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[88]",
            },
            {
              attribute_id: 235,
              coverage_tag: "OTRVAL",
              description_tag: "Otros Valores Agregados",
              is_product_tag: null,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Emergencias en Carretera",
              source: "quotation",
            },
          ],
        },
      ],
    },
    {
      id_db: 25220,
      process_id: "112531815",
      duration_days: "365",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/Liberty-1-LYW119-1003813097_20251009T164535.858Z_80QPwx5N.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "liberty_express",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: false,
      process_comments: [""],
      product_type: "individual",
      score: 67,
      provider: null,
      total_price: 6604804,
      total_price_anual: 6604804,
      price_type: "anual",
      total_price_month: 0,
      products: [
        {
          price: 6604804,
          name: "Integral",
          description:
            "Integral\n\nResponsabilidad Civil Extracontractual (Limite global): $4.400.000.000\nDeducible ante pago de Responsabilidad Civil: Sin Deducible\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\nAmparo Patrimonial: SI\nAsistencia jurídica procesos penales/civiles: SI\nDeducible Pérdida Total Daños: 10%, minimo 0 SMMLV\nDeducible Pérdida Parcial Daños: Deducible Unico: 2 SMMLV\nDeducible Pérdida Total Hurto: 10%, minimo 0 SMMLV\nDeducible Pérdida Parcial Hurto: Deducible Unico: 2 SMMLV\nDeducible ante eventos de la naturaleza como temblor, terremoto: Deducible Unico: 1 SMMLV\nVehículo de reemplazo ante Pérdidas Totales: Hasta 21 dias\nVehículo de reemplazo ante Pérdidas Parciales: Hasta 10 dias\nGastos de Transporte por Pérdidas Totales: SI\nAccidentes personales en accidentes de tránsito: NO\nResponsabilidad Civil Familiar: NO\nAsistencia en Viaje: Basica\nAsistencia Odontológica: NO\nGastos exequiales por accidente de tránsito: NO\nAsistencia ante unidad Judicial de tránsito o centro conciliador: \nTramites De Transito: \nOtros Valores Agregados: Aplica para instalacion del DISPOSITIVO DE RASTREO Y LOCALIZACION DETEKTOR EL CAZADOR - PDF para mas informacion\nRotura de vidrios: \nLlantas estalladas: \nPérdida de llaves: \nPequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.): \nAsesoría legal telefónica en trámites o procedimientos de tránsito: No Cubre\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/liberty.jpg",
          manufacturer: "Liberty",
          coverages: [
            {
              attribute_id: 173,
              coverage_tag: "GASPAR",
              description_tag: "Gastos de Transporte por Pérdidas Parciales",
              is_product_tag: false,
              priority: 2,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(36)",
            },
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "NO",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Basica",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$4.400.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "10%, minimo 0 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "SI",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sin Deducible",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Unico: 2 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 200,
              coverage_tag: "VEHRPT",
              description_tag: "Vehículo de reemplazo ante Pérdidas Totales",
              is_product_tag: false,
              priority: 3,
              group_id: 30,
              tag_group: "VEHRPT",
              action_tag: "R",
              view_status: "2",
              description: "Hasta 21 dias",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "10%, minimo 0 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 206,
              coverage_tag: "VEHRPP",
              description_tag: "Vehículo de reemplazo ante Pérdidas Parciales",
              is_product_tag: false,
              priority: 4,
              group_id: 30,
              tag_group: "VEHRPP",
              action_tag: "R",
              view_status: "1",
              description: "Hasta 10 dias",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Unico: 2 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "SI",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 219,
              coverage_tag: "RESEXC",
              description_tag: "Responsabilidad civil en exceso",
              is_product_tag: false,
              priority: 6,
              group_id: 28,
              tag_group: "RESEXC",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "catalog(36)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Unico: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "SI",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 230,
              coverage_tag: "LUCCES",
              description_tag: "Lucro Cesante",
              is_product_tag: false,
              priority: 9,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 253,
              coverage_tag: "TRASIT",
              description_tag: "Tramites De Transito",
              is_product_tag: false,
              priority: 10,
              group_id: 79,
              tag_group: false,
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 257,
              coverage_tag: "RECFAM",
              description_tag: "Responsabilidad Civil Familiar",
              is_product_tag: false,
              priority: 14,
              group_id: 79,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "1",
              description: "NO",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: false,
              source: "catalog(36)",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: false,
              source: "catalog(36)",
            },
            {
              attribute_id: 384,
              coverage_tag: "ASLETT",
              description_tag:
                "Asesoría legal telefónica en trámites o procedimientos de tránsito",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "quotation",
            },
            {
              attribute_id: 391,
              coverage_tag: "GASCAS",
              description_tag: "Gastos exequiales por accidente de tránsito",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "NO",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 958,
              coverage_tag: "GASMED",
              description_tag: "Gastos Médicos por accidente de tránsito",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 999,
              coverage_tag: "ASIODO",
              description_tag: "Asistencia Odontológica",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "NO",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 1002,
              coverage_tag: "URLCLA",
              description_tag: "Url Clausulado Aseguradoras",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "https://l.agentemotor.com/z04db74",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 203,
              coverage_tag: "ASJUVE",
              description_tag:
                "Asistencia Jurídica para liberación de vehículo",
              is_product_tag: false,
              priority: 2,
              group_id: 34,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencia jurídica",
              source: "asists[257]",
            },
            {
              attribute_id: 208,
              coverage_tag: "CONELG",
              description_tag: "Conductor elegido",
              is_product_tag: false,
              priority: 3,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "2",
              description: "Hasta 10 servicios por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[257]",
            },
            {
              attribute_id: 209,
              coverage_tag: "ASJUTC",
              description_tag:
                "Asistencia ante unidad Judicial de tránsito o centro conciliador",
              is_product_tag: false,
              priority: 3,
              group_id: 34,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description:
                "2 audiencias, sólo en caso de suspensión de la primera",
              res: "1",
              group: "Asistencia jurídica",
              source: "asists[257]",
            },
            {
              attribute_id: 368,
              coverage_tag: "SERGRD",
              description_tag: "Servicio de grúa en caso de avería",
              is_product_tag: false,
              priority: 11,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "50 SMDLV por evento - 3 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[257]",
            },
            {
              attribute_id: 369,
              coverage_tag: "SERGRU",
              description_tag: "Servicio de grúa en caso de accidente o varada",
              is_product_tag: false,
              priority: 4,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "80 SMDLV por evento - 2 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[257]",
            },
            {
              attribute_id: 375,
              coverage_tag: "CARDES",
              description_tag:
                "Servicio de carro taller (Pinchazo, varada por gasolina, cerrajería)",
              is_product_tag: false,
              priority: 2,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "3 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[257]",
            },
            {
              attribute_id: 382,
              coverage_tag: "ASTEAC",
              description_tag:
                "Asistencia jurídica telefónica en caso de accidente",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[257]",
            },
            {
              attribute_id: 235,
              coverage_tag: "OTRVAL",
              description_tag: "Otros Valores Agregados",
              is_product_tag: null,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description:
                "Aplica para instalacion del DISPOSITIVO DE RASTREO Y LOCALIZACION DETEKTOR EL CAZADOR - PDF para mas informacion",
              source: "quotation",
            },
          ],
        },
      ],
    },
    {
      id_db: 25221,
      process_id: "112531816",
      duration_days: "365",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/Liberty-1-LYW119-1003813097_20251009T164536.239Z_vFitAfYG.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "liberty_express",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: false,
      process_comments: [""],
      product_type: "individual",
      score: 68,
      provider: null,
      total_price: 6805449,
      total_price_anual: 6805449,
      price_type: "anual",
      total_price_month: 0,
      products: [
        {
          price: 6805449,
          name: "Premium",
          description:
            "Premium\n\nResponsabilidad Civil Extracontractual (Limite global): $4.400.000.000\nDeducible ante pago de Responsabilidad Civil: Sin Deducible\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\nAmparo Patrimonial: SI\nAsistencia jurídica procesos penales/civiles: SI\nDeducible Pérdida Total Daños: Sin Deducible\nDeducible Pérdida Parcial Daños: Deducible Unico: 1 SMMLV\nDeducible Pérdida Total Hurto: Sin Deducible\nDeducible Pérdida Parcial Hurto: Deducible Unico: 1 SMMLV\nDeducible ante eventos de la naturaleza como temblor, terremoto: Deducible Unico: 1 SMMLV\nVehículo de reemplazo ante Pérdidas Totales: Hasta 21 dias\nVehículo de reemplazo ante Pérdidas Parciales: Hasta 10 dias\nGastos de Transporte por Pérdidas Totales: SI\nAccidentes personales en accidentes de tránsito: 40000000\nResponsabilidad Civil Familiar: SI\nAsistencia en Viaje: Tradicional\nAsistencia Odontológica: SI\nGastos exequiales por accidente de tránsito: SI\nAsistencia ante unidad Judicial de tránsito o centro conciliador: SI\nTramites De Transito: SI\nOtros Valores Agregados: Aplica para instalacion del DISPOSITIVO DE RASTREO Y LOCALIZACION DETEKTOR EL CAZADOR - PDF para mas informacion\nRotura de vidrios: 1.0 SMMLV\nLlantas estalladas: 1.5 SMMLV\nPérdida de llaves: 1.0 SMMLV\nPequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.): 1.0 SMMLV\nAsesoría legal telefónica en trámites o procedimientos de tránsito: Si Cubre\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/liberty.jpg",
          manufacturer: "Liberty",
          coverages: [
            {
              attribute_id: 173,
              coverage_tag: "GASPAR",
              description_tag: "Gastos de Transporte por Pérdidas Parciales",
              is_product_tag: false,
              priority: 2,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(36)",
            },
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "40000000",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Tradicional",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$4.400.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "SI",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sin Deducible",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Unico: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 200,
              coverage_tag: "VEHRPT",
              description_tag: "Vehículo de reemplazo ante Pérdidas Totales",
              is_product_tag: false,
              priority: 3,
              group_id: 30,
              tag_group: "VEHRPT",
              action_tag: "R",
              view_status: "2",
              description: "Hasta 21 dias",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 206,
              coverage_tag: "VEHRPP",
              description_tag: "Vehículo de reemplazo ante Pérdidas Parciales",
              is_product_tag: false,
              priority: 4,
              group_id: 30,
              tag_group: "VEHRPP",
              action_tag: "R",
              view_status: "1",
              description: "Hasta 10 dias",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Unico: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "SI",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 219,
              coverage_tag: "RESEXC",
              description_tag: "Responsabilidad civil en exceso",
              is_product_tag: false,
              priority: 6,
              group_id: 28,
              tag_group: "RESEXC",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "catalog(36)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Unico: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "SI",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 230,
              coverage_tag: "LUCCES",
              description_tag: "Lucro Cesante",
              is_product_tag: false,
              priority: 9,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 253,
              coverage_tag: "TRASIT",
              description_tag: "Tramites De Transito",
              is_product_tag: false,
              priority: 10,
              group_id: 79,
              tag_group: false,
              action_tag: "R",
              view_status: "1",
              description: "SI",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 257,
              coverage_tag: "RECFAM",
              description_tag: "Responsabilidad Civil Familiar",
              is_product_tag: false,
              priority: 14,
              group_id: 79,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "1",
              description: "SI",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "1.5 SMMLV",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "1.0 SMMLV",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "1.0 SMMLV",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "1.0 SMMLV",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 384,
              coverage_tag: "ASLETT",
              description_tag:
                "Asesoría legal telefónica en trámites o procedimientos de tránsito",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "quotation",
            },
            {
              attribute_id: 391,
              coverage_tag: "GASCAS",
              description_tag: "Gastos exequiales por accidente de tránsito",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "SI",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 958,
              coverage_tag: "GASMED",
              description_tag: "Gastos Médicos por accidente de tránsito",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 999,
              coverage_tag: "ASIODO",
              description_tag: "Asistencia Odontológica",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "SI",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 1002,
              coverage_tag: "URLCLA",
              description_tag: "Url Clausulado Aseguradoras",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "https://l.agentemotor.com/z04db74",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 203,
              coverage_tag: "ASJUVE",
              description_tag:
                "Asistencia Jurídica para liberación de vehículo",
              is_product_tag: false,
              priority: 2,
              group_id: 34,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencia jurídica",
              source: "asists[258]",
            },
            {
              attribute_id: 208,
              coverage_tag: "CONELG",
              description_tag: "Conductor elegido",
              is_product_tag: false,
              priority: 3,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "2",
              description: "10 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 209,
              coverage_tag: "ASJUTC",
              description_tag:
                "Asistencia ante unidad Judicial de tránsito o centro conciliador",
              is_product_tag: false,
              priority: 3,
              group_id: 34,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "SI",
              res: "1",
              group: "Asistencia jurídica",
              source: "quotation",
            },
            {
              attribute_id: 242,
              coverage_tag: "ASISHO",
              description_tag: "Asistencia al hogar",
              is_product_tag: true,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "asists[258]",
            },
            {
              attribute_id: 368,
              coverage_tag: "SERGRD",
              description_tag: "Servicio de grúa en caso de avería",
              is_product_tag: false,
              priority: 11,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "50 SMDLV por evento - Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 369,
              coverage_tag: "SERGRU",
              description_tag: "Servicio de grúa en caso de accidente o varada",
              is_product_tag: false,
              priority: 4,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description:
                "Hasta 50 SMDLV por avería. Hasta 80 SMDLV por accidente. Un (1) trayecto por evento.",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 374,
              coverage_tag: "INFTRE",
              description_tag: "Revisión antes de viaje",
              is_product_tag: false,
              priority: 1,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "2 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 375,
              coverage_tag: "CARDES",
              description_tag:
                "Servicio de carro taller (Pinchazo, varada por gasolina, cerrajería)",
              is_product_tag: false,
              priority: 2,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 378,
              coverage_tag: "DECUVE",
              description_tag:
                "Depósito o custodia del vehículo después de reparado",
              is_product_tag: false,
              priority: 8,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "45 SMDLV",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 381,
              coverage_tag: "INFVIA",
              description_tag: "Informe del estado de las vías",
              is_product_tag: false,
              priority: false,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 382,
              coverage_tag: "ASTEAC",
              description_tag:
                "Asistencia jurídica telefónica en caso de accidente",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 235,
              coverage_tag: "OTRVAL",
              description_tag: "Otros Valores Agregados",
              is_product_tag: null,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description:
                "Aplica para instalacion del DISPOSITIVO DE RASTREO Y LOCALIZACION DETEKTOR EL CAZADOR - PDF para mas informacion",
              source: "quotation",
            },
          ],
        },
      ],
    },
    {
      id_db: 25213,
      process_id: "106794365",
      duration_days: "365",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/HDI-106794365-LYW119.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "liberty_ws",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: false,
      process_comments: [""],
      product_type: "individual",
      score: 66,
      provider: null,
      total_price: 762249,
      total_price_anual: 762249,
      price_type: "anual",
      total_price_month: 0,
      products: [
        {
          price: 762249,
          name: "HDI Seguros - Basico",
          description:
            "HDI Seguros - Basico\n\nDeducible Pérdida Total Hurto: No Cubre\nDeducible Pérdida Total Daños: No Cubre\nDeducible Pérdida Parcial Daños: No Cubre\nDeducible Pérdida Parcial Hurto: No Cubre\nDeducible ante eventos de la naturaleza como temblor, terremoto: No Cubre\nAmparo Patrimonial: Si Cubre\nGastos de Transporte por Pérdidas Totales: No Cubre\nGastos de Transporte por Pérdidas Totales: No Cubre\nVehículo de reemplazo ante Pérdidas Totales: No Cubre\nAccidentes personales en accidentes de tránsito: No Cubre\nResponsabilidad Civil Familiar: No Cubre\nRotura de vidrios: No Cubre\nAsistencia jurídica procesos penales/civiles: Si Cubre\nAsistencia jurídica procesos penales/civiles: Si Cubre\nAsistencia en Viaje: HDI Autos\nAsistencia Odontológica: No Cubre\nGastos exequiales por accidente de tránsito: No Cubre\nTramites De Transito: No Cubre\nLucro Cesante: No Cubre\nGastos Médicos por accidente de tránsito: No Cubre\nLlantas estalladas: No Cubre\nPequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.): No Cubre\nObligaciones Financieras: No Cubre\nDeducible ante pago de Responsabilidad Civil: No Cubre\nPérdida de llaves: No Cubre\nDeducible ante pago de Responsabilidad Civil: Sin Deducible\nResponsabilidad Civil Extracontractual (Limite global): $4.400.000.000\nOtros Valores Agregados: Aplica, Vehículo obligado a instalar Dispositivo de rastreo satelital\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/liberty.jpg",
          manufacturer: "Liberty",
          coverages: [
            {
              attribute_id: 173,
              coverage_tag: "GASPAR",
              description_tag: "Gastos de Transporte por Pérdidas Parciales",
              is_product_tag: false,
              priority: 2,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(36)",
            },
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "HDI Autos",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$4.400.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sin Deducible",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 200,
              coverage_tag: "VEHRPT",
              description_tag: "Vehículo de reemplazo ante Pérdidas Totales",
              is_product_tag: false,
              priority: 3,
              group_id: 30,
              tag_group: "VEHRPT",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 206,
              coverage_tag: "VEHRPP",
              description_tag: "Vehículo de reemplazo ante Pérdidas Parciales",
              is_product_tag: false,
              priority: 4,
              group_id: 30,
              tag_group: "VEHRPP",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(36)",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 219,
              coverage_tag: "RESEXC",
              description_tag: "Responsabilidad civil en exceso",
              is_product_tag: false,
              priority: 6,
              group_id: 28,
              tag_group: "RESEXC",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "catalog(36)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 230,
              coverage_tag: "LUCCES",
              description_tag: "Lucro Cesante",
              is_product_tag: false,
              priority: 9,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 253,
              coverage_tag: "TRASIT",
              description_tag: "Tramites De Transito",
              is_product_tag: false,
              priority: 10,
              group_id: 79,
              tag_group: false,
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 257,
              coverage_tag: "RECFAM",
              description_tag: "Responsabilidad Civil Familiar",
              is_product_tag: false,
              priority: 14,
              group_id: 79,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 384,
              coverage_tag: "ASLETT",
              description_tag:
                "Asesoría legal telefónica en trámites o procedimientos de tránsito",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "catalog(36)",
            },
            {
              attribute_id: 391,
              coverage_tag: "GASCAS",
              description_tag: "Gastos exequiales por accidente de tránsito",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 958,
              coverage_tag: "GASMED",
              description_tag: "Gastos Médicos por accidente de tránsito",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 999,
              coverage_tag: "ASIODO",
              description_tag: "Asistencia Odontológica",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 1002,
              coverage_tag: "URLCLA",
              description_tag: "Url Clausulado Aseguradoras",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "https://l.agentemotor.com/z04db74",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 203,
              coverage_tag: "ASJUVE",
              description_tag:
                "Asistencia Jurídica para liberación de vehículo",
              is_product_tag: false,
              priority: 2,
              group_id: 34,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencia jurídica",
              source: "asists[258]",
            },
            {
              attribute_id: 208,
              coverage_tag: "CONELG",
              description_tag: "Conductor elegido",
              is_product_tag: false,
              priority: 3,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "2",
              description: "10 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 209,
              coverage_tag: "ASJUTC",
              description_tag:
                "Asistencia ante unidad Judicial de tránsito o centro conciliador",
              is_product_tag: false,
              priority: 3,
              group_id: 34,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "2 audiencias por vigencia",
              res: "1",
              group: "Asistencia jurídica",
              source: "asists[258]",
            },
            {
              attribute_id: 242,
              coverage_tag: "ASISHO",
              description_tag: "Asistencia al hogar",
              is_product_tag: true,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "asists[258]",
            },
            {
              attribute_id: 368,
              coverage_tag: "SERGRD",
              description_tag: "Servicio de grúa en caso de avería",
              is_product_tag: false,
              priority: 11,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "50 SMDLV por evento - Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 369,
              coverage_tag: "SERGRU",
              description_tag: "Servicio de grúa en caso de accidente o varada",
              is_product_tag: false,
              priority: 4,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description:
                "Hasta 50 SMDLV por avería. Hasta 80 SMDLV por accidente. Un (1) trayecto por evento.",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 374,
              coverage_tag: "INFTRE",
              description_tag: "Revisión antes de viaje",
              is_product_tag: false,
              priority: 1,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "2 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 375,
              coverage_tag: "CARDES",
              description_tag:
                "Servicio de carro taller (Pinchazo, varada por gasolina, cerrajería)",
              is_product_tag: false,
              priority: 2,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 378,
              coverage_tag: "DECUVE",
              description_tag:
                "Depósito o custodia del vehículo después de reparado",
              is_product_tag: false,
              priority: 8,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "45 SMDLV",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 381,
              coverage_tag: "INFVIA",
              description_tag: "Informe del estado de las vías",
              is_product_tag: false,
              priority: false,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 382,
              coverage_tag: "ASTEAC",
              description_tag:
                "Asistencia jurídica telefónica en caso de accidente",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 235,
              coverage_tag: "OTRVAL",
              description_tag: "Otros Valores Agregados",
              is_product_tag: null,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description:
                "Aplica, Vehículo obligado a instalar Dispositivo de rastreo satelital",
              source: "quotation",
            },
          ],
        },
      ],
    },
    {
      id_db: 25214,
      process_id: "106794367",
      duration_days: "365",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/HDI-106794367-LYW119.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "liberty_ws",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: false,
      process_comments: [""],
      product_type: "individual",
      score: 70,
      provider: null,
      total_price: 6159453,
      total_price_anual: 6159453,
      price_type: "anual",
      total_price_month: 0,
      products: [
        {
          price: 6159453,
          name: "HDI Seguros - Integral",
          description:
            "HDI Seguros - Integral\n\nDeducible Pérdida Total Hurto: Sin Deducible\nDeducible Pérdida Total Daños: Sin Deducible\nDeducible Pérdida Parcial Daños: Deducible Único: 1 SMMLV\nDeducible Pérdida Parcial Hurto: Deducible Único: 1 SMMLV\nDeducible ante eventos de la naturaleza como temblor, terremoto: Deducible Único: 1 SMMLV\nAmparo Patrimonial: Si Cubre\nGastos de Transporte por Pérdidas Totales: $1.200.000\nVehículo de reemplazo ante Pérdidas Totales: No Cubre\nAccidentes personales en accidentes de tránsito: No Cubre\nResponsabilidad Civil Familiar: No Cubre\nRotura de vidrios: No Cubre\nAsistencia jurídica procesos penales/civiles: Si Cubre\nAsistencia jurídica procesos penales/civiles: Si Cubre\nAsistencia en Viaje: HDI Autos\nAsistencia Odontológica: No Cubre\nGastos exequiales por accidente de tránsito: No Cubre\nTramites De Transito: No Cubre\nLucro Cesante: No Cubre\nGastos Médicos por accidente de tránsito: No Cubre\nLlantas estalladas: No Cubre\nPequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.): No Cubre\nObligaciones Financieras: No Cubre\nDeducible ante pago de Responsabilidad Civil: No Cubre\nPérdida de llaves: No Cubre\nDeducible ante pago de Responsabilidad Civil: Sin Deducible\nResponsabilidad Civil Extracontractual (Limite global): $4.400.000.000\nOtros Valores Agregados: Aplica, Vehículo obligado a instalar Dispositivo de rastreo satelital\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/liberty.jpg",
          manufacturer: "Liberty",
          coverages: [
            {
              attribute_id: 173,
              coverage_tag: "GASPAR",
              description_tag: "Gastos de Transporte por Pérdidas Parciales",
              is_product_tag: false,
              priority: 2,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(36)",
            },
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "HDI Autos",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$4.400.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "$1.200.000",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sin Deducible",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 200,
              coverage_tag: "VEHRPT",
              description_tag: "Vehículo de reemplazo ante Pérdidas Totales",
              is_product_tag: false,
              priority: 3,
              group_id: 30,
              tag_group: "VEHRPT",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 206,
              coverage_tag: "VEHRPP",
              description_tag: "Vehículo de reemplazo ante Pérdidas Parciales",
              is_product_tag: false,
              priority: 4,
              group_id: 30,
              tag_group: "VEHRPP",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(36)",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 219,
              coverage_tag: "RESEXC",
              description_tag: "Responsabilidad civil en exceso",
              is_product_tag: false,
              priority: 6,
              group_id: 28,
              tag_group: "RESEXC",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "catalog(36)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 230,
              coverage_tag: "LUCCES",
              description_tag: "Lucro Cesante",
              is_product_tag: false,
              priority: 9,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 253,
              coverage_tag: "TRASIT",
              description_tag: "Tramites De Transito",
              is_product_tag: false,
              priority: 10,
              group_id: 79,
              tag_group: false,
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 257,
              coverage_tag: "RECFAM",
              description_tag: "Responsabilidad Civil Familiar",
              is_product_tag: false,
              priority: 14,
              group_id: 79,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 384,
              coverage_tag: "ASLETT",
              description_tag:
                "Asesoría legal telefónica en trámites o procedimientos de tránsito",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "catalog(36)",
            },
            {
              attribute_id: 391,
              coverage_tag: "GASCAS",
              description_tag: "Gastos exequiales por accidente de tránsito",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 958,
              coverage_tag: "GASMED",
              description_tag: "Gastos Médicos por accidente de tránsito",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 999,
              coverage_tag: "ASIODO",
              description_tag: "Asistencia Odontológica",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 1002,
              coverage_tag: "URLCLA",
              description_tag: "Url Clausulado Aseguradoras",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "https://l.agentemotor.com/z04db74",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 203,
              coverage_tag: "ASJUVE",
              description_tag:
                "Asistencia Jurídica para liberación de vehículo",
              is_product_tag: false,
              priority: 2,
              group_id: 34,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencia jurídica",
              source: "asists[258]",
            },
            {
              attribute_id: 208,
              coverage_tag: "CONELG",
              description_tag: "Conductor elegido",
              is_product_tag: false,
              priority: 3,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "2",
              description: "10 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 209,
              coverage_tag: "ASJUTC",
              description_tag:
                "Asistencia ante unidad Judicial de tránsito o centro conciliador",
              is_product_tag: false,
              priority: 3,
              group_id: 34,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "2 audiencias por vigencia",
              res: "1",
              group: "Asistencia jurídica",
              source: "asists[258]",
            },
            {
              attribute_id: 242,
              coverage_tag: "ASISHO",
              description_tag: "Asistencia al hogar",
              is_product_tag: true,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "asists[258]",
            },
            {
              attribute_id: 368,
              coverage_tag: "SERGRD",
              description_tag: "Servicio de grúa en caso de avería",
              is_product_tag: false,
              priority: 11,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "50 SMDLV por evento - Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 369,
              coverage_tag: "SERGRU",
              description_tag: "Servicio de grúa en caso de accidente o varada",
              is_product_tag: false,
              priority: 4,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description:
                "Hasta 50 SMDLV por avería. Hasta 80 SMDLV por accidente. Un (1) trayecto por evento.",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 374,
              coverage_tag: "INFTRE",
              description_tag: "Revisión antes de viaje",
              is_product_tag: false,
              priority: 1,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "2 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 375,
              coverage_tag: "CARDES",
              description_tag:
                "Servicio de carro taller (Pinchazo, varada por gasolina, cerrajería)",
              is_product_tag: false,
              priority: 2,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 378,
              coverage_tag: "DECUVE",
              description_tag:
                "Depósito o custodia del vehículo después de reparado",
              is_product_tag: false,
              priority: 8,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "45 SMDLV",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 381,
              coverage_tag: "INFVIA",
              description_tag: "Informe del estado de las vías",
              is_product_tag: false,
              priority: false,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 382,
              coverage_tag: "ASTEAC",
              description_tag:
                "Asistencia jurídica telefónica en caso de accidente",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 235,
              coverage_tag: "OTRVAL",
              description_tag: "Otros Valores Agregados",
              is_product_tag: null,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description:
                "Aplica, Vehículo obligado a instalar Dispositivo de rastreo satelital",
              source: "quotation",
            },
          ],
        },
      ],
    },
    {
      id_db: 25217,
      process_id: "106794366",
      duration_days: "365",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/HDI-106794366-LYW119.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "liberty_ws",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: false,
      process_comments: [""],
      product_type: "individual",
      score: 70,
      provider: null,
      total_price: 6291002,
      total_price_anual: 6291002,
      price_type: "anual",
      total_price_month: 0,
      products: [
        {
          price: 6291002,
          name: "HDI Seguros - Premium",
          description:
            "HDI Seguros - Premium\n\nDeducible Pérdida Total Hurto: Sin Deducible\nDeducible Pérdida Total Daños: Sin Deducible\nDeducible Pérdida Parcial Daños: Deducible Único: 1 SMMLV\nDeducible Pérdida Parcial Hurto: Deducible Único: 1 SMMLV\nDeducible ante eventos de la naturaleza como temblor, terremoto: Deducible Único: 1 SMMLV\nAmparo Patrimonial: Si Cubre\nGastos de Transporte por Pérdidas Totales: $1.200.000\nVehículo de reemplazo ante Pérdidas Totales: Si Cubre\nVehículo de reemplazo ante Pérdidas Parciales: Si Cubre\nAccidentes personales en accidentes de tránsito: Hasta 40000000\nResponsabilidad Civil Familiar: $44.000.000\nRotura de vidrios: Sin Franquicia\nAsistencia jurídica procesos penales/civiles: Si Cubre\nAsistencia jurídica procesos penales/civiles: Si Cubre\nAsistencia en Viaje: HDI Autos\nAsistencia Odontológica: Si Cubre\nGastos exequiales por accidente de tránsito: Si Cubre\nTramites De Transito: Si Cubre\nLucro Cesante: No Cubre\nGastos Médicos por accidente de tránsito: No Cubre\nLlantas estalladas: Si Cubre\nPequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.): Si Cubre\nObligaciones Financieras: No Cubre\nDeducible ante pago de Responsabilidad Civil: No Cubre\nPérdida de llaves: Si Cubre\nDeducible ante pago de Responsabilidad Civil: Sin Deducible\nResponsabilidad Civil Extracontractual (Limite global): $4.400.000.000\nOtros Valores Agregados: Aplica, Vehículo obligado a instalar Dispositivo de rastreo satelital\nAsesoría legal telefónica en trámites o procedimientos de tránsito: Si Cubre\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/liberty.jpg",
          manufacturer: "Liberty",
          coverages: [
            {
              attribute_id: 173,
              coverage_tag: "GASPAR",
              description_tag: "Gastos de Transporte por Pérdidas Parciales",
              is_product_tag: false,
              priority: 2,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(36)",
            },
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Hasta 40000000",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "HDI Autos",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$4.400.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "$1.200.000",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sin Deducible",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 200,
              coverage_tag: "VEHRPT",
              description_tag: "Vehículo de reemplazo ante Pérdidas Totales",
              is_product_tag: false,
              priority: 3,
              group_id: 30,
              tag_group: "VEHRPT",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 206,
              coverage_tag: "VEHRPP",
              description_tag: "Vehículo de reemplazo ante Pérdidas Parciales",
              is_product_tag: false,
              priority: 4,
              group_id: 30,
              tag_group: "VEHRPP",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 219,
              coverage_tag: "RESEXC",
              description_tag: "Responsabilidad civil en exceso",
              is_product_tag: false,
              priority: 6,
              group_id: 28,
              tag_group: "RESEXC",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "catalog(36)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 230,
              coverage_tag: "LUCCES",
              description_tag: "Lucro Cesante",
              is_product_tag: false,
              priority: 9,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 253,
              coverage_tag: "TRASIT",
              description_tag: "Tramites De Transito",
              is_product_tag: false,
              priority: 10,
              group_id: 79,
              tag_group: false,
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 257,
              coverage_tag: "RECFAM",
              description_tag: "Responsabilidad Civil Familiar",
              is_product_tag: false,
              priority: 14,
              group_id: 79,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "1",
              description: "$44.000.000",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Sin Franquicia",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 384,
              coverage_tag: "ASLETT",
              description_tag:
                "Asesoría legal telefónica en trámites o procedimientos de tránsito",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "quotation",
            },
            {
              attribute_id: 391,
              coverage_tag: "GASCAS",
              description_tag: "Gastos exequiales por accidente de tránsito",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 958,
              coverage_tag: "GASMED",
              description_tag: "Gastos Médicos por accidente de tránsito",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 999,
              coverage_tag: "ASIODO",
              description_tag: "Asistencia Odontológica",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 1002,
              coverage_tag: "URLCLA",
              description_tag: "Url Clausulado Aseguradoras",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "https://l.agentemotor.com/z04db74",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 203,
              coverage_tag: "ASJUVE",
              description_tag:
                "Asistencia Jurídica para liberación de vehículo",
              is_product_tag: false,
              priority: 2,
              group_id: 34,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencia jurídica",
              source: "asists[258]",
            },
            {
              attribute_id: 208,
              coverage_tag: "CONELG",
              description_tag: "Conductor elegido",
              is_product_tag: false,
              priority: 3,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "2",
              description: "10 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 209,
              coverage_tag: "ASJUTC",
              description_tag:
                "Asistencia ante unidad Judicial de tránsito o centro conciliador",
              is_product_tag: false,
              priority: 3,
              group_id: 34,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "2 audiencias por vigencia",
              res: "1",
              group: "Asistencia jurídica",
              source: "asists[258]",
            },
            {
              attribute_id: 242,
              coverage_tag: "ASISHO",
              description_tag: "Asistencia al hogar",
              is_product_tag: true,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "asists[258]",
            },
            {
              attribute_id: 368,
              coverage_tag: "SERGRD",
              description_tag: "Servicio de grúa en caso de avería",
              is_product_tag: false,
              priority: 11,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "50 SMDLV por evento - Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 369,
              coverage_tag: "SERGRU",
              description_tag: "Servicio de grúa en caso de accidente o varada",
              is_product_tag: false,
              priority: 4,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description:
                "Hasta 50 SMDLV por avería. Hasta 80 SMDLV por accidente. Un (1) trayecto por evento.",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 374,
              coverage_tag: "INFTRE",
              description_tag: "Revisión antes de viaje",
              is_product_tag: false,
              priority: 1,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "2 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 375,
              coverage_tag: "CARDES",
              description_tag:
                "Servicio de carro taller (Pinchazo, varada por gasolina, cerrajería)",
              is_product_tag: false,
              priority: 2,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 378,
              coverage_tag: "DECUVE",
              description_tag:
                "Depósito o custodia del vehículo después de reparado",
              is_product_tag: false,
              priority: 8,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "45 SMDLV",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 381,
              coverage_tag: "INFVIA",
              description_tag: "Informe del estado de las vías",
              is_product_tag: false,
              priority: false,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 382,
              coverage_tag: "ASTEAC",
              description_tag:
                "Asistencia jurídica telefónica en caso de accidente",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 235,
              coverage_tag: "OTRVAL",
              description_tag: "Otros Valores Agregados",
              is_product_tag: null,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description:
                "Aplica, Vehículo obligado a instalar Dispositivo de rastreo satelital",
              source: "quotation",
            },
          ],
        },
      ],
    },
    {
      id_db: 25219,
      process_id: "106794368",
      duration_days: "365",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/HDI-106794368-LYW119.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "liberty_ws",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: false,
      process_comments: [""],
      product_type: "individual",
      score: 74,
      provider: null,
      total_price: 3504005,
      total_price_anual: 3504005,
      price_type: "anual",
      total_price_month: 0,
      products: [
        {
          price: 3504005,
          name: "HDI Seguros - Full colectiva",
          description:
            "HDI Seguros - Full colectiva\n\nDeducible Pérdida Total Hurto: Sín Deducíble\nDeducible Pérdida Total Daños: Sín Deducíble\nDeducible Pérdida Parcial Daños: Deducible Único: 1 SMMLV\nDeducible Pérdida Parcial Hurto: Deducible Único: 1 SMMLV\nDeducible ante eventos de la naturaleza como temblor, terremoto: Deducible Único: 1 SMMLV\nAmparo Patrimonial: Si Cubre\nGastos de Transporte por Pérdidas Totales: $1.200.000\nVehículo de reemplazo ante Pérdidas Totales: Si Cubre\nVehículo de reemplazo ante Pérdidas Parciales: Si Cubre\nAccidentes personales en accidentes de tránsito: Hasta 50000000\nResponsabilidad Civil Familiar: $33.000.000\nRotura de vidrios: No Cubre\nAsistencia jurídica procesos penales/civiles: Si Cubre\nAsistencia jurídica procesos penales/civiles: Si Cubre\nAsistencia en Viaje: HDI Autos\nAsistencia Odontológica: Si Cubre\nGastos exequiales por accidente de tránsito: Si Cubre\nTramites De Transito: Si Cubre\nLucro Cesante: No Cubre\nGastos Médicos por accidente de tránsito: No Cubre\nLlantas estalladas: Si Cubre\nPequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.): Si Cubre\nObligaciones Financieras: No Cubre\nDeducible ante pago de Responsabilidad Civil: No Cubre\nPérdida de llaves: No Cubre\nDeducible ante pago de Responsabilidad Civil: Sín Deducíble\nResponsabilidad Civil Extracontractual (Limite global): $4.400.000.000\nOtros Valores Agregados: Aplica, Vehículo obligado a instalar Dispositivo de rastreo satelital\nAsesoría legal telefónica en trámites o procedimientos de tránsito: Si Cubre\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/liberty.jpg",
          manufacturer: "Liberty",
          coverages: [
            {
              attribute_id: 173,
              coverage_tag: "GASPAR",
              description_tag: "Gastos de Transporte por Pérdidas Parciales",
              is_product_tag: false,
              priority: 2,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(36)",
            },
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Hasta 50000000",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "HDI Autos",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$4.400.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "Sín Deducíble",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "$1.200.000",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sín Deducíble",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 200,
              coverage_tag: "VEHRPT",
              description_tag: "Vehículo de reemplazo ante Pérdidas Totales",
              is_product_tag: false,
              priority: 3,
              group_id: 30,
              tag_group: "VEHRPT",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "Sín Deducíble",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 206,
              coverage_tag: "VEHRPP",
              description_tag: "Vehículo de reemplazo ante Pérdidas Parciales",
              is_product_tag: false,
              priority: 4,
              group_id: 30,
              tag_group: "VEHRPP",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 219,
              coverage_tag: "RESEXC",
              description_tag: "Responsabilidad civil en exceso",
              is_product_tag: false,
              priority: 6,
              group_id: 28,
              tag_group: "RESEXC",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "catalog(36)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "Deducible Único: 1 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 230,
              coverage_tag: "LUCCES",
              description_tag: "Lucro Cesante",
              is_product_tag: false,
              priority: 9,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 253,
              coverage_tag: "TRASIT",
              description_tag: "Tramites De Transito",
              is_product_tag: false,
              priority: 10,
              group_id: 79,
              tag_group: false,
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 257,
              coverage_tag: "RECFAM",
              description_tag: "Responsabilidad Civil Familiar",
              is_product_tag: false,
              priority: 14,
              group_id: 79,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "1",
              description: "$33.000.000",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 384,
              coverage_tag: "ASLETT",
              description_tag:
                "Asesoría legal telefónica en trámites o procedimientos de tránsito",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "quotation",
            },
            {
              attribute_id: 391,
              coverage_tag: "GASCAS",
              description_tag: "Gastos exequiales por accidente de tránsito",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 958,
              coverage_tag: "GASMED",
              description_tag: "Gastos Médicos por accidente de tránsito",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 999,
              coverage_tag: "ASIODO",
              description_tag: "Asistencia Odontológica",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 1002,
              coverage_tag: "URLCLA",
              description_tag: "Url Clausulado Aseguradoras",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "https://l.agentemotor.com/z04db74",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(36)",
            },
            {
              attribute_id: 203,
              coverage_tag: "ASJUVE",
              description_tag:
                "Asistencia Jurídica para liberación de vehículo",
              is_product_tag: false,
              priority: 2,
              group_id: 34,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencia jurídica",
              source: "asists[258]",
            },
            {
              attribute_id: 208,
              coverage_tag: "CONELG",
              description_tag: "Conductor elegido",
              is_product_tag: false,
              priority: 3,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "2",
              description: "10 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 209,
              coverage_tag: "ASJUTC",
              description_tag:
                "Asistencia ante unidad Judicial de tránsito o centro conciliador",
              is_product_tag: false,
              priority: 3,
              group_id: 34,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "2 audiencias por vigencia",
              res: "1",
              group: "Asistencia jurídica",
              source: "asists[258]",
            },
            {
              attribute_id: 242,
              coverage_tag: "ASISHO",
              description_tag: "Asistencia al hogar",
              is_product_tag: true,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "asists[258]",
            },
            {
              attribute_id: 368,
              coverage_tag: "SERGRD",
              description_tag: "Servicio de grúa en caso de avería",
              is_product_tag: false,
              priority: 11,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "50 SMDLV por evento - Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 369,
              coverage_tag: "SERGRU",
              description_tag: "Servicio de grúa en caso de accidente o varada",
              is_product_tag: false,
              priority: 4,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description:
                "Hasta 50 SMDLV por avería. Hasta 80 SMDLV por accidente. Un (1) trayecto por evento.",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 374,
              coverage_tag: "INFTRE",
              description_tag: "Revisión antes de viaje",
              is_product_tag: false,
              priority: 1,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "2 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 375,
              coverage_tag: "CARDES",
              description_tag:
                "Servicio de carro taller (Pinchazo, varada por gasolina, cerrajería)",
              is_product_tag: false,
              priority: 2,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 378,
              coverage_tag: "DECUVE",
              description_tag:
                "Depósito o custodia del vehículo después de reparado",
              is_product_tag: false,
              priority: 8,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "45 SMDLV",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 381,
              coverage_tag: "INFVIA",
              description_tag: "Informe del estado de las vías",
              is_product_tag: false,
              priority: false,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 382,
              coverage_tag: "ASTEAC",
              description_tag:
                "Asistencia jurídica telefónica en caso de accidente",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[258]",
            },
            {
              attribute_id: 235,
              coverage_tag: "OTRVAL",
              description_tag: "Otros Valores Agregados",
              is_product_tag: null,
              priority: 10,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description:
                "Aplica, Vehículo obligado a instalar Dispositivo de rastreo satelital",
              source: "quotation",
            },
          ],
        },
      ],
    },
    {
      id_db: 25279,
      process_id: "03174721",
      duration_days: "365",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/Qualitas - 12079-Vehiculos-1003813097-LYW119-KIA-SPORTAGE.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "qualitas_ws",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: false,
      process_comments: [""],
      product_type: "individual",
      score: 66,
      provider: null,
      total_price: 436969.2,
      total_price_anual: 436969.2,
      price_type: "anual",
      total_price_month: 0,
      products: [
        {
          price: 436969.2,
          name: "Qualitas - Base",
          description:
            "Qualitas - Base\n\nResponsabilidad Civil Extracontractual (Limite global): $3.000.000.000\nDeducible ante pago de Responsabilidad Civil: Sin deducible\nAsistencia jurídica procesos penales/civiles: Si Cubre\nAsistencia en Viaje: BASICA\nAccidentes personales en accidentes de tránsito: Si Cubre\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/qualitas.jpg",
          manufacturer: "Qualitas",
          coverages: [
            {
              attribute_id: 173,
              coverage_tag: "GASPAR",
              description_tag: "Gastos de Transporte por Pérdidas Parciales",
              is_product_tag: false,
              priority: 2,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(1882)",
            },
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "BASICA",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$3.000.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(1882)",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sin deducible",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 236,
              coverage_tag: "CUBREP",
              description_tag: "Reposición del vehículo por pérdida total",
              is_product_tag: false,
              priority: 20,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: false,
              source: "catalog(1882)",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(1882)",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(1882)",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: false,
              source: "catalog(1882)",
            },
            {
              attribute_id: 2806,
              coverage_tag: "IMPOTA",
              description_tag: "Importante",
              is_product_tag: false,
              priority: 9,
              group_id: 79,
              tag_group: false,
              action_tag: "R",
              view_status: "1",
              description:
                "Pago de PTD y PTH Valor Convenido en caratula de la póliza (en caso de pérdida total, se paga a valor carátula), RCE Extendida aplica con vehículos de características similares",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(1882)",
            },
            {
              attribute_id: 208,
              coverage_tag: "CONELG",
              description_tag: "Conductor elegido",
              is_product_tag: false,
              priority: 3,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "2",
              description: "2 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[2080]",
            },
            {
              attribute_id: 369,
              coverage_tag: "SERGRU",
              description_tag: "Servicio de grúa en caso de accidente o varada",
              is_product_tag: false,
              priority: 4,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description:
                "Por accidente: Ilimitada Por averia: 2 eventos hasta $1 M por evento",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[2080]",
            },
            {
              attribute_id: 374,
              coverage_tag: "INFTRE",
              description_tag: "Revisión antes de viaje",
              is_product_tag: false,
              priority: 1,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[2080]",
            },
            {
              attribute_id: 375,
              coverage_tag: "CARDES",
              description_tag:
                "Servicio de carro taller (Pinchazo, varada por gasolina, cerrajería)",
              is_product_tag: false,
              priority: 2,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Ilimitada",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[2080]",
            },
            {
              attribute_id: 382,
              coverage_tag: "ASTEAC",
              description_tag:
                "Asistencia jurídica telefónica en caso de accidente",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[2080]",
            },
            {
              attribute_id: 384,
              coverage_tag: "ASLETT",
              description_tag:
                "Asesoría legal telefónica en trámites o procedimientos de tránsito",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[2080]",
            },
            {
              attribute_id: 992,
              coverage_tag: "TRCUVE",
              description_tag:
                "Transporte o Custodia del Vehículo reparado o recuperado",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "15 SMDLV",
              res: "1",
              group: false,
              source: "asists[2080]",
            },
          ],
        },
      ],
    },
    {
      id_db: 25280,
      process_id: "03174722",
      duration_days: "365",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/Qualitas - 12079-Vehiculos-1003813097-LYW119-KIA-SPORTAGE.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "qualitas_ws",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: false,
      process_comments: [""],
      product_type: "individual",
      score: 67,
      provider: null,
      total_price: 3573191.63,
      total_price_anual: 3573191.63,
      price_type: "anual",
      total_price_month: 0,
      products: [
        {
          price: 3573191.63,
          name: "Qualitas - Plus",
          description:
            "Qualitas - Plus\n\nDeducible ante eventos de la naturaleza como temblor, terremoto: Si Cubre\nPérdida total y/o destrucción total: $127.400.000\nDeducible Pérdida Total Daños: Sin Deducible\nResponsabilidad Civil Extracontractual (Limite global): $3.000.000.000\nDeducible ante pago de Responsabilidad Civil: Sin deducible\nAsistencia jurídica procesos penales/civiles: Si Cubre\nAsistencia en Viaje: BASICA\nDeducible Pérdida Total Hurto: Sin Deducible\nAccidentes personales en accidentes de tránsito: Si Cubre\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/qualitas.jpg",
          manufacturer: "Qualitas",
          coverages: [
            {
              attribute_id: 173,
              coverage_tag: "GASPAR",
              description_tag: "Gastos de Transporte por Pérdidas Parciales",
              is_product_tag: false,
              priority: 2,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(1882)",
            },
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "BASICA",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$3.000.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Garantías de Movilidad",
              source: "catalog(1882)",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sin deducible",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 236,
              coverage_tag: "CUBREP",
              description_tag: "Reposición del vehículo por pérdida total",
              is_product_tag: false,
              priority: 20,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: false,
              source: "catalog(1882)",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(1882)",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(1882)",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: false,
              source: "catalog(1882)",
            },
            {
              attribute_id: 2806,
              coverage_tag: "IMPOTA",
              description_tag: "Importante",
              is_product_tag: false,
              priority: 9,
              group_id: 79,
              tag_group: false,
              action_tag: "R",
              view_status: "1",
              description:
                "Pago de PTD y PTH Valor Convenido en caratula de la póliza (en caso de pérdida total, se paga a valor carátula), RCE Extendida aplica con vehículos de características similares",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(1882)",
            },
            {
              attribute_id: 208,
              coverage_tag: "CONELG",
              description_tag: "Conductor elegido",
              is_product_tag: false,
              priority: 3,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "2",
              description: "2 eventos por vigencia",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[2080]",
            },
            {
              attribute_id: 369,
              coverage_tag: "SERGRU",
              description_tag: "Servicio de grúa en caso de accidente o varada",
              is_product_tag: false,
              priority: 4,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description:
                "Por accidente: Ilimitada Por averia: 2 eventos hasta $1 M por evento",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[2080]",
            },
            {
              attribute_id: 374,
              coverage_tag: "INFTRE",
              description_tag: "Revisión antes de viaje",
              is_product_tag: false,
              priority: 1,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[2080]",
            },
            {
              attribute_id: 375,
              coverage_tag: "CARDES",
              description_tag:
                "Servicio de carro taller (Pinchazo, varada por gasolina, cerrajería)",
              is_product_tag: false,
              priority: 2,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Ilimitada",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[2080]",
            },
            {
              attribute_id: 382,
              coverage_tag: "ASTEAC",
              description_tag:
                "Asistencia jurídica telefónica en caso de accidente",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[2080]",
            },
            {
              attribute_id: 384,
              coverage_tag: "ASLETT",
              description_tag:
                "Asesoría legal telefónica en trámites o procedimientos de tránsito",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[2080]",
            },
            {
              attribute_id: 992,
              coverage_tag: "TRCUVE",
              description_tag:
                "Transporte o Custodia del Vehículo reparado o recuperado",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "15 SMDLV",
              res: "1",
              group: false,
              source: "asists[2080]",
            },
          ],
        },
      ],
    },
    {
      id_db: 25281,
      process_id: "03174720",
      duration_days: "365",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/Qualitas - 12079-Vehiculos-1003813097-LYW119-KIA-SPORTAGE.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "qualitas_ws",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: false,
      process_comments: [""],
      product_type: "individual",
      score: 0,
      provider: null,
      total_price: 9801415.83,
      total_price_anual: 9801415.83,
      price_type: "anual",
      total_price_month: 0,
      products: [
        {
          price: 9801415.83,
          name: "Qualitas - Amplia",
          description:
            "Qualitas - Amplia\n\nDeducible ante eventos de la naturaleza como temblor, terremoto: Si Cubre\nDeducible Pérdida Parcial Daños: $1.000.000\nPérdida total y/o destrucción total: $127.400.000\nDeducible Pérdida Total Daños: 10%, mínimo 0 SMMLV\nDeducible Pérdida Parcial Hurto: $1.000.000\nResponsabilidad Civil Extracontractual (Limite global): $2.500.000.000\nDeducible ante pago de Responsabilidad Civil: Sin deducible\nGastos Médicos por accidente de tránsito: Si Cubre\nAsistencia jurídica procesos penales/civiles: Si Cubre\nPérdida de llaves: Si Cubre\nGastos de Transporte por Pérdidas Totales: $1.500.000\nGastos de Transporte por Pérdidas Parciales: $75.000 - 30 días\nLlantas estalladas: Si Cubre\nDeducible Pérdida Total Hurto: 10%, mínimo 0 SMMLV\nAccidentes personales en accidentes de tránsito: Si Cubre\nGastos médicos por accidente - Mascota: $5.000.000\nPequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.): Si Cubre\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/qualitas.jpg",
          manufacturer: "Qualitas",
          coverages: [
            {
              attribute_id: 173,
              coverage_tag: "GASPAR",
              description_tag: "Gastos de Transporte por Pérdidas Parciales",
              is_product_tag: false,
              priority: 2,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "$75.000 - 30 días",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "BASICA",
              res: "1",
              group: false,
              source: "catalog(1882)",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$2.500.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "10%, mínimo 0 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "$1.500.000",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sin deducible",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "$1.000.000",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "10%, mínimo 0 SMMLV",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "$1.000.000",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 236,
              coverage_tag: "CUBREP",
              description_tag: "Reposición del vehículo por pérdida total",
              is_product_tag: false,
              priority: 20,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "No Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(1882)",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 2806,
              coverage_tag: "IMPOTA",
              description_tag: "Importante",
              is_product_tag: false,
              priority: 9,
              group_id: 79,
              tag_group: false,
              action_tag: "R",
              view_status: "1",
              description:
                "Pago de PTD y PTH Valor Convenido en caratula de la póliza (en caso de pérdida total, se paga a valor carátula), RCE Extendida aplica con vehículos de características similares",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(1882)",
            },
          ],
        },
      ],
    },
    {
      id_db: 25282,
      process_id: "03174723",
      duration_days: "365",
      discount_tec: 0,
      amount_quoted: 127400000,
      financing_installments: "",
      document_reference: {
        url: "https://agm-storage-pro.s3.us-east-2.amazonaws.com/tmp/smoke-3.co.agentemotor.com/documentos/polizas_pdf/octubre/event-create-quote/Qualitas - 12079-Vehiculos-1003813097-LYW119-KIA-SPORTAGE.pdf",
        extension: "pdf",
        origin: "EXT",
      },
      offer_expiration_date: "2025-11-07",
      discount_com: 0,
      source: "qualitas_ws",
      points_rating: 0,
      view_status: "Visible",
      comments: "",
      favorite: false,
      process_comments: [""],
      product_type: "individual",
      score: 0,
      provider: null,
      total_price: 9434749.01,
      total_price_anual: 9434749.01,
      price_type: "anual",
      total_price_month: 0,
      products: [
        {
          price: 9434749.01,
          name: "Qualitas - Amplia",
          description:
            "Qualitas - Amplia\n\nDeducible ante eventos de la naturaleza como temblor, terremoto: Si Cubre\nDeducible Pérdida Parcial Daños: $1.400.000\nPérdida total y/o destrucción total: $127.400.000\nDeducible Pérdida Total Daños: Sin Deducible\nDeducible Pérdida Parcial Hurto: $1.400.000\nResponsabilidad Civil Extracontractual (Limite global): $4.000.000.000\nDeducible ante pago de Responsabilidad Civil: Sin deducible\nGastos Médicos por accidente de tránsito: Si Cubre\nAsistencia jurídica procesos penales/civiles: Si Cubre\nAsistencia en Viaje: PLUS\nPérdida de llaves: Si Cubre\nGastos de Transporte por Pérdidas Totales: $1.500.000\nGastos de Transporte por Pérdidas Parciales: $75.000 - 15 días\nLlantas estalladas: Si Cubre\nRotura de vidrios: Si Cubre\nDeducible Pérdida Total Hurto: Sin Deducible\nAccidentes personales en accidentes de tránsito: Si Cubre\nGastos médicos por accidente - Mascota: $5.000.000\nPequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.): Si Cubre\nLímite para daños a bienes de terceros: Limite único\nLímite para lesiones o muerte a una persona: Limite único\nLímite para lesiones o muerte a dos o más personas: Limite único\n",
          logo: "https://s3.us-east-2.amazonaws.com/fs.agentemotor.com/logos/qualitas.jpg",
          manufacturer: "Qualitas",
          coverages: [
            {
              attribute_id: 173,
              coverage_tag: "GASPAR",
              description_tag: "Gastos de Transporte por Pérdidas Parciales",
              is_product_tag: false,
              priority: 2,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "$75.000 - 15 días",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 174,
              coverage_tag: "AMPACC",
              description_tag:
                "Accidentes personales en accidentes de tránsito",
              is_product_tag: false,
              priority: 2,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 189,
              coverage_tag: "ASIVIA",
              description_tag: "Asistencia en Viaje",
              is_product_tag: true,
              priority: 1,
              group_id: false,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "PLUS",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 192,
              coverage_tag: "RESEXT",
              description_tag:
                "Responsabilidad Civil Extracontractual (Limite global)",
              is_product_tag: false,
              priority: 1,
              group_id: 28,
              tag_group: "RESEXT",
              action_tag: "R",
              view_status: "2",
              description: "$4.000.000.000",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 193,
              coverage_tag: "DEBPTD",
              description_tag: "Deducible Pérdida Total Daños",
              is_product_tag: false,
              priority: 1,
              group_id: 29,
              tag_group: "DEBPTD",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 194,
              coverage_tag: "ASISMO",
              description_tag: "Gastos de Transporte por Pérdidas Totales",
              is_product_tag: false,
              priority: 1,
              group_id: 30,
              tag_group: "ASISMO",
              action_tag: "R",
              view_status: "1",
              description: "$1.500.000",
              res: "1",
              group: "Garantías de Movilidad",
              source: "quotation",
            },
            {
              attribute_id: 198,
              coverage_tag: "DEDRES",
              description_tag: "Deducible ante pago de Responsabilidad Civil",
              is_product_tag: false,
              priority: 2,
              group_id: 28,
              tag_group: "DEDRES",
              action_tag: "R",
              view_status: "1",
              description: "Sin deducible",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 199,
              coverage_tag: "DEBPPD",
              description_tag: "Deducible Pérdida Parcial Daños",
              is_product_tag: false,
              priority: 2,
              group_id: 29,
              tag_group: "DEBPPD",
              action_tag: "R",
              view_status: "2",
              description: "$1.400.000",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 204,
              coverage_tag: "LITDBT",
              description_tag: "Límite para daños a bienes de terceros",
              is_product_tag: false,
              priority: 3,
              group_id: 28,
              tag_group: "LITDBT",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 205,
              coverage_tag: "DEBPTH",
              description_tag: "Deducible Pérdida Total Hurto",
              is_product_tag: false,
              priority: 3,
              group_id: 29,
              tag_group: "DEBPTH",
              action_tag: "R",
              view_status: "2",
              description: "Sin Deducible",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 210,
              coverage_tag: "LITLMP",
              description_tag: "Límite para lesiones o muerte a una persona",
              is_product_tag: false,
              priority: 4,
              group_id: 28,
              tag_group: "LITLMP",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 211,
              coverage_tag: "DEBPPH",
              description_tag: "Deducible Pérdida Parcial Hurto",
              is_product_tag: false,
              priority: 4,
              group_id: 29,
              tag_group: "DEBPPH",
              action_tag: "R",
              view_status: "2",
              description: "$1.400.000",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 215,
              coverage_tag: "LILMTS",
              description_tag:
                "Límite para lesiones o muerte a dos o más personas",
              is_product_tag: false,
              priority: 5,
              group_id: 28,
              tag_group: "LILMTS",
              action_tag: "R",
              view_status: "1",
              description: "Limite único",
              res: "1",
              group: "Responsabilidad Civil Extracontractual",
              source: "quotation",
            },
            {
              attribute_id: 216,
              coverage_tag: "AMPPAT",
              description_tag: "Amparo Patrimonial",
              is_product_tag: false,
              priority: 6,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 220,
              coverage_tag: "EVNNAT",
              description_tag:
                "Deducible ante eventos de la naturaleza como temblor, terremoto",
              is_product_tag: false,
              priority: 5,
              group_id: 29,
              tag_group: "EVNNAT",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 223,
              coverage_tag: "ASIJUD",
              description_tag: "Asistencia jurídica procesos penales/civiles",
              is_product_tag: false,
              priority: 7,
              group_id: 29,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "2",
              description: "Si Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "quotation",
            },
            {
              attribute_id: 236,
              coverage_tag: "CUBREP",
              description_tag: "Reposición del vehículo por pérdida total",
              is_product_tag: false,
              priority: 20,
              group_id: 29,
              tag_group: "NULL",
              action_tag: "R",
              view_status: "0",
              description: "No Cubre",
              res: "1",
              group:
                "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
              source: "catalog(1882)",
            },
            {
              attribute_id: 370,
              coverage_tag: "LLAEST",
              description_tag: "Llantas estalladas",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 371,
              coverage_tag: "ROTVID",
              description_tag: "Rotura de vidrios",
              is_product_tag: false,
              priority: false,
              group_id: 79,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 372,
              coverage_tag: "PEQACC",
              description_tag:
                "Pequeños accesorios (Tapa gasolina, Boceles, Lunas, Emblemas, etc.)",
              is_product_tag: false,
              priority: 1,
              group_id: 79,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Valor Diferencial",
              source: "quotation",
            },
            {
              attribute_id: 373,
              coverage_tag: "REPLLA",
              description_tag: "Pérdida de llaves",
              is_product_tag: false,
              priority: 2,
              group_id: false,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: false,
              source: "quotation",
            },
            {
              attribute_id: 2806,
              coverage_tag: "IMPOTA",
              description_tag: "Importante",
              is_product_tag: false,
              priority: 9,
              group_id: 79,
              tag_group: false,
              action_tag: "R",
              view_status: "1",
              description:
                "Pago de PTD y PTH Valor Convenido en caratula de la póliza (en caso de pérdida total, se paga a valor carátula), RCE Extendida aplica con vehículos de características similares",
              res: "1",
              group: "Valor Diferencial",
              source: "catalog(1882)",
            },
            {
              attribute_id: 208,
              coverage_tag: "CONELG",
              description_tag: "Conductor elegido",
              is_product_tag: false,
              priority: 3,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "2",
              description: "Ilimitada",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[1915]",
            },
            {
              attribute_id: 369,
              coverage_tag: "SERGRU",
              description_tag: "Servicio de grúa en caso de accidente o varada",
              is_product_tag: false,
              priority: 4,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description:
                "Por accidente: Ilimitada Por averia: 5 eventos hasta $2 M por evento",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[1915]",
            },
            {
              attribute_id: 375,
              coverage_tag: "CARDES",
              description_tag:
                "Servicio de carro taller (Pinchazo, varada por gasolina, cerrajería)",
              is_product_tag: false,
              priority: 2,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "Ilimitada",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[1915]",
            },
            {
              attribute_id: 382,
              coverage_tag: "ASTEAC",
              description_tag:
                "Asistencia jurídica telefónica en caso de accidente",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "0",
              description: "Sin límite de eventos",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[1915]",
            },
            {
              attribute_id: 384,
              coverage_tag: "ASLETT",
              description_tag:
                "Asesoría legal telefónica en trámites o procedimientos de tránsito",
              is_product_tag: false,
              priority: 5,
              group_id: 73,
              tag_group: "OTRVAL",
              action_tag: "R",
              view_status: "1",
              description: "Si Cubre",
              res: "1",
              group: "Asistencias al vehículo",
              source: "asists[1915]",
            },
            {
              attribute_id: 992,
              coverage_tag: "TRCUVE",
              description_tag:
                "Transporte o Custodia del Vehículo reparado o recuperado",
              is_product_tag: false,
              priority: false,
              group_id: false,
              tag_group: "ASIVIA",
              action_tag: "R",
              view_status: "1",
              description: "40 SMDLV",
              res: "1",
              group: false,
              source: "asists[1915]",
            },
            {
              attribute_id: 1393,
              coverage_tag: "SERAMH",
              description_tag: "Servicio de Ambulancia",
              is_product_tag: false,
              priority: 7,
              group_id: 79,
              tag_group: false,
              action_tag: "R",
              view_status: "1",
              description: "Hasta 30 millones ",
              res: "1",
              group: "Valor Diferencial",
              source: "asists[1915]",
            },
          ],
        },
      ],
    },
  ],
  broker: {
    name: "Lebron James",
    email: "maysanchezg16@gmail.com",
    phone: "",
    mobile: "3235646546",
    company: {
      id: 1,
      name: "Smoke 3 LTDA.",
      address: "calle 15 #1-2",
      website: "https://smoke-3.co.agentemotor.com",
    },
  },
  expired_offers: false,
  groups: {
    28: {
      group_id: 28,
      group: "Responsabilidad Civil Extracontractual",
      priority: 2,
    },
    29: {
      group_id: 29,
      group:
        "Protección Ante Daños o Hurto Sobre el Valor Asegurado para el Momento de un Siniestro",
      priority: 3,
    },
    30: {
      group_id: 30,
      group: "Garantías de Movilidad",
      priority: 4,
    },
    34: {
      group_id: 34,
      group: "Asistencia jurídica",
      priority: 8,
    },
    73: {
      group_id: 73,
      group: "Asistencias al vehículo",
      priority: 5,
    },
    79: {
      group_id: 79,
      group: "Valor Diferencial",
      priority: 12,
    },
    false: {
      group_id: false,
      group: false,
      priority: false,
    },
  },
  tenant_data: {
    name: "smoke-3.co.agentemotor.com",
    user: 497,
    company: 1,
    origin: "form-risk-insurance",
    third_party: false,
    third_party_identification: false,
    additional_coverages: {
      RCEX: "SI",
      LUCCES: "NO",
      CHEVAR: "NO",
      incentives: "NO",
    },
  },
};

const messageResponse = {
  jsonrpc: "2.0",
  id: 1,
  result: [
    {
      author: "master_agentemotor",
      subject: "",
      create_date: "2023-04-05 08:34:43",
      message:
        '{"name":"message-policy","insurer":"ESTADO","interface":"ESTADO PORTALESTADO","status":"Datos erroneos","message":"No se recibieron las coberturas para el producto.","url":null,"data":"❌ ESTADO -  PORTALESTADO - Datos erroneos :: No se recibieron las coberturas para el producto."}',
      avatar:
        "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",
    },
    {
      author: "master_agentemotor",
      subject: "",
      create_date: "2023-04-05 08:34:35",
      message:
        '{"name":"message-policy","insurer":"SOLIDARIA","interface":"SOLIDARIA WEB SERVICE","status":"Acceso denegado","message":"El nombre de usuario o la contraseña no son correctos.","url":null,"data":"❌ SOLIDARIA -  WEB SERVICE - Acceso denegado :: El nombre de usuario o la contraseña no son correctos."}',
      avatar:
        "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",
    },
    {
      author: "master_agentemotor",
      subject: "",
      create_date: "2023-04-05 08:34:43",
      message:
        '{"name":"message-policy","insurer":"ESTADO","interface":"ESTADO PORTALESTADO","status":"Datos erroneos","message":"No se recibieron las coberturas para el producto.","url":null,"data":"❌ ESTADO -  PORTALESTADO - Datos erroneos :: No se recibieron las coberturas para el producto."}',
      avatar:
        "iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAyHUlEQVR42u2dd5yV1ZnHv+ec97bpzAxDRwFFxQaKBWPEhiD2gpo1psfEmGLcjUmMCcymaIyJsSVuTDZmXV3jaCTGKAKKGruooAiKKFXqDDDt1vecs3+c9713Zhj6FFDv5zPcmWHuved9n/57mmCve1gxFUQt04Kfa03b/z2TudVZotUKXQWiv4b9BQwXUAOUA2U2eAaqgpc1AE0CGoEmoNHCegsfKHgP7FqDrI+Qa3iUsfXtzzNVAkxlGrVgQdi96W6KvYXo43lanciJphbRgeDvVGdIj1NwNIhDgMHAALADI5QJi8ZisBjAYrEQfLnfgUAGt0Ig8s8y+FLkaLIWsVrAGoFcadFvG3g5SvylRzmwHUNMxcqneVo+w4l6b2AGsacTfgrIOoQOfzOBeTUQOVBiThbokyxypMBWRyj1QGDIYvCx+AC+xTqKIhDu+/DSO1y7zRPLIqxjEqxwRPQkHgIPSRSLxafJt8h6gVkMPAXyaYgvnMHIDeH7TMGqOjB7MiOIPZPodbKOi9oSvVgiTgFxksCeo0gMayvFBh+wviOeE2FHbNFF12etYwqsCDgDRMAUBe2hSX5gkY+AnRMhN/tRxiYLzPCAqmPKHscMexQDOInJS7uYyJvHWsylAnmCwB4aoQKfFgw5Q6CoyUu16OFrCTWGsDbgCUlEepSQYzMW3hTYOQL5v49z2GuB3el4jZ8wQMGpcw7UeOZ4UconKNSVwGRFXDjpSgHkAAXIPVSjGkADEUUCsGjSBtRjkLttBqNnOQ3Q/po/tgzg1GJB1U9k/meAr0giJ0s8NCks1oCwAit7Xsp3y2QYsEIgpKIIQwaDP0vAf89g9P1buwcfGwYIL3w8c+IJqi4Ac7VAHaFI4NNqLBaBkHwEHhZrBAiPEuGYWr9ukL/J0PDQM5yU7k0mEL0p9ZOZdwxEfiqJTjD4GLIAfqDmBR+ph7U42+9Jokg8DNlZkPvxY4x+ube0gegN4o/igegQDrhG4v2HIlqeI6n3LhXfNSbCo0gZso1gblzOopsWclG2p5mgh264lUGEZifx+nhB9HpJdFwQs2uBUHwMHxarJZ6SRDFkX/TJ/GAWRz5LAbsw3X0G2f1Sb5W7EGEnMu+HgthMQWScT9JYfPtxJX4QxiqLb32SRhAZFyE2cxJv/sBFBsK4e7fXaoACivdpXhlSQtEtksh5mgwWYz4qDl7XOopSKuJocg9labryKcatC3ADQx6A2isYwIowvj2d108XxG+TxEbkaPmY2fqdIIQEIZxvELElKmfS72jS353JkTM63tM93ARYWSD+W9MgPh3EiBxNRoD6hPgdCC9AeQJtLK3aiqQ2qtU0GqXUgRFR9PeJvPnj4C9tmHncYzXAVKysRZizWVSaIfP7CKWX+rQE6u0Tld+R8AjwjSWNoaY8ypCDYihPsG5ZlhWrUiaCksWylIxpvjdG7IpHOKg5vMd7HAMcydzIa4zNncprAxXe3RFKJnyi8jt/KCXwtSWLYcDAKKd8tpITLi5n0AExlBJsWJnl9ZktTL9tg13+btoUyzKVMS2zNP4XZnPk6iP5r8hrfC23BzGAlSDMqby4v0fJ/R6JI3xafcD7hNwdpB5IWk1R3GPiZZVc+L2+DNo/2unfr3k/y01fWMHc51r8ClHmZW3ydZ+WS2Yz7r3wnvc6A4xnjvcMJ/kTmHeMh/d/gsgwTUp/nMO7zggvBGSNRQBjJ5Zy3rf7ctTkUgCMAaxFSBHARGCNRXmCtR9kuXbiB6xYktYJWaS0yS21ZC+ewRGvdkVmcbfs8lSsfIaT/NN480AP+aAk+gnxO1H32kLKGPoPjXLVnYOp/fswjppcijGO2FKCVIVKAykDx1BD/+FRzryiChDKtyktiQ4D78HTePPAOoSe6kC2nmeA0BmZyMIBEvugIDrYJ/kJ8duFddCsfWLFgi/+pD+/eW4/Jn+tikhMYLRFBn9jA0YQHbwlKd3/HXhMMYmIACuUT1JLokMltm4yC/rXIszuMIHcNeJPlbUIcxoLKgX+/YqigzUp8wnxHQGlgoxx4jz+7Ap+/thwLqvtT98hkYLUBxKvfZsn/Ouzmln1biZvBkJG6tPfQ0UkNkAPNSmjKDrEou8/jQWVjgl2LUQUu/Yay+W85q0gcr9Hyfk+LZ84fAJkENblsAw/IMHnf9qP4y+oQEhHaKmEk3BbkHiATWtzPHDjBqbfsYEbZozg8JNKMNr5BELA0gVprhr7HpmMbUsw36PEy9E8vQzv4joOzgXk3CmwaCeJVkhSLGPezVFKz8/RpAXiY018qUBraLWG6soI5367mjO+XkWffh42cPKUJ/IOX6j6cxnLY3c18M/fNfDWolaOHF3K8NGJQPIDn0DA6sUZMlkTlMAVaJejWUcpO7eRxptBXOmAomnsDGK4U4QLsf2JvPEFj6IrfVr9j3UyRzgpTmlDSVRx8sVVfOZHNQw5INae2IGkG+20AMBrTzRz73+u480XWlAIolJy8AnFlPZRaG1RSmCCCvYlb6TwLURF29plEAiZo9WPUPyNibzx6hOMuXsK01SdK0vragaYKusQehILRgnk9YacsfhKIMXHkvACcsaS05Yx40q49Cf9OHJSENbpwBeQYUjntIRUgtXvZfifaet4/qFGWjOahJQgIeYL9j04Fija9p+1dF4ajXU2pj1phcVXBmkksetPZ+ELdYjFO4MW7igDCKi1U1gQbUbfpYj1z9FiPo7El0qgtSVtDfvsE+fsb1Ux6SuVFJervHTKQCca42gmFDTWax6/q4FHf1fPylVZipDEpcRa8H1LcbFiyKh4Xv3bQHs0rPZZ/lYahejUugukMGRthJL+OZK/n8KC02td8azYEX9A7pjqdwUdTeRqFcXH5WjVAik/nupe4xUJzvlyNbe/sT8X/HtfistVXupFoKaNdgQ0BuY+0cy/f+o97rz2Q9avylGqHIfYQEYNUFSuGHpQPP9ZJogi5j3ZzMrlaaJSbJWcAilztGqP4pObyNSCsFN4QHaJBnAlSkKfzryTBYnvGNJhzd7HSt1njEVby/Gnl3Ph92o4/KTigrqXTupDBE8q5xm991qK+362nlf+0UhaG4qlwgJa2w4xlWXIQVHKqlRBawTK9d1XkqQwxJVC57Yp0NKQ9hXFV01i/uw6Dn9yR8rLtscAoo637bG8kDDYmzxIGHwjPibJHanA15actex3UIJzvl3NaV+sJBITnat7CUIJ6lfl+OedDTxyewMNjTkSSGJCOsi3s9jKwsmX9snH5TYAgZIthg/mp4khscZux0YLYfGlJBq32Bsmsfj4Ou7drinwtqf66xC6jLO/7VE8xpUuffTTuqHqTmpDZaXHGV+t4sJraiirdNTWvs2HdaEal9KFdXPu3cx9v1jLivczRBAUK4U1tp333vZhDJQmPEafXLoFMtOwMsvq9zJ4iK2+viP+6JM0HkVjDclvQu2vt6cFvG1DvZhTmDdSIq825Kz4yJVqbz2siyI5/dJKzvlWXw44JpEnVljAgXWqPGSE12c18+CvNjB3VjMGSAQOntF2m4yWNoYDDimipE8bqxrE/+tW5GhYn8MTIs9oO+CtC0POgrzmFOb9o47D39tWVLA1BhALqRMwxXpwrUdxTY7mjyzO3zas87XlgEOL+Mx1NZxwUUV7Ox/UNofqPszW/eOOeqbfUk9KG+JCBk7cjn2wxrLvoTESpbKdCQB4+1+t5IxFbcMB7OxNDTkdobTGo+la4IuOlp2bgq0wwFRRx0V6IvMmSqKfdSHfR5P4KgjrUgGKd+lP+nHyZ/tQVhWEdbaNnW/DCNq3PPDLDfzzjw18uCxDDFmQ+p3M0g8dlXBMo9vAxcCr/2xGIna6HNQBRC1GEfu3Sbx5Tx0XPelQwlq7g7kA17z4EvOf90gc6xockR9FqW8xmrKox0mfreCcb1UzIoBijS4Qvi2YA/DSP5p4+DcbeOXpZhSCmJLbVPVb+3xjIZoQ/PSfw7bA/z98L8O3xy6hucl3JmCny0GtUSSkJvVCKYtP2FpruteJ46fqEPol5p8t8Y7SpO1HifjtijMsHPHpUj7z/RqOPqPMOXjahWGFsM59LxR8MD/N9Fs3MPO/N5IDigIoZGeJH4I9Ge2z/0ElHHB0kcsQCoExFqEEC59PkmzRKMQu1oMLqUlbgXdME6POAPFIZwUkXkfJrwMznjmexV6uiKuPUmmXVAJfGzLWMmx4nEuuq+HEiyqIFcuCg7dFWAfNGzV/vWE9s+/exOoNGYpRxOTOq/r2oZ/z9EYenSBeLPORhTBOKS99M03GGBJS7s7naEXc0zR/bTxzHnM5gvbl5bK99NdJEDZK5XGK6ASfpKEHulO6XeqD7Fur1hSXe0y5si83zhnBxC9WOuK3Lc5o4+Rp3/LMXxv5wanvc++v1rFxQ44yz2sX/u0yAxiICcGhny5xTXNS5FPEftay8p20m2C0W5CLVT5Jo4hNiFJ5nEMI6+RWNYCzEyARVyiikRw5vTfH/SHhM9rl0Y+fXM5lU/tzwNHtwzqpRD5kU56zwe+8nOSeqeuY+0QTPpYi6QoytL/7vRlCgLaWsgqPfQ6OBxOMHIoolCsLXzo/RQQRaIpd/ySLNR7RiMG/Ang2pHEnDOBUw2ReO8hgL/RpRezFkK+UhZr7Q0aXcN53qxl/SQWRqCgQXhakUQRh3frlOabftoGZf9rIhs0+xUKihNgtdd8pAARUD45Qs09ki/BvxcIMq1ZnKVZql/yLDl6+Cmh54SQW/HQGYmFbM+AV1D+yDrRBfVYS8wxpw14o/VI5Dz5lDFVVEc6/rJLLamsoKlN5hy3MyYeMICSkk4YXpzfx5+vWsHxpmjiSEqVcUqare3QF+Nay/5EJiitU/ncywP/nP9WCG5DRVQ9rJHHPkv434LqQ1m0YIO/8lVg4QxDWn+1d3j3CoXieFEy8pJJ/u64fQw5qU5whCrV4pk1YN+/JFu6+dg0LX0ligRLpYa3dbenbunYS5IxlzGmleaYMw79ks+GNp5qJIvMZwd0mP8IKFBoz+fMs/dlfIBNqAQ9gPKhnEH4Rb44TyAM1qb0G9m2H4gVh3QVXVzPu3PKCs9a2OEOHxRnO0/77rfXM/p+NJHNtUbzum9skJOR8w8DKKMMPj2/x/2s+yNLwYa5L426BlZqUlcQOXE/jcSCecv0c+B5Y8Uyg5DR2UoySmGGzz15Q5yeDFivfGmr6Rzj/uzWcdWUV8WKHyIU193lgJwjrko2Gx//YwP03rqd+fS6P4hm7+979jkh/q9EcdVSCQfvFgjO68i8hYOXCNC2NBsmugD/bhJ18j7JEjsYzgKee4UQDNiSyMOeysCpD7nxNq93TbX++xUpriuOKs7/Ul3OvqmbQ/rF2KF4Y1llbAHaef7CRul+t5+1XWpEIigJHy5ieObu1br7hkIPieKFDKgnSvYJ3Xk6SsS7+70pmtCA1SYCzT2PBz2ciNoIVXjivLol/RITEvntyyje087lARR99UikXfq+Go04vba/uO6J4Apa8luLhWzYw855NGCAmJAi6zc5vzfmz2hJDMmhkrMAROPuvfct7c50fIoTAduFMCIGQmqzxiO9nSB4JzJoKwgumbguJmeDQ6T3T9CslyGmDby01/aN86YYBnHBRBbGEaOfNd0Tx0klD3S838NBtG2je5OcJb7tt5sY26Y+Pq/874Kig/FuIfGSy6JUky97K7FAByK6fQFiJnADMqmUaHkyzUGst9oRAyPasWbZBCrZJ+1SXu5r7yV+rpnqQt0VY17Y4Q/uWx/6wkUd/18B7byfxEMTDuLoXr9AAfYdEGHZ4wiGAbVLHC59vpb4pS6ny2peNdSH5wYqA1sA064GwZ/DuIE1yf+NGqu8RAUAozVljiQrBKef34eJrajjwmKJOUbywFg/grWdbeeCG9Tz/eCMSsUPFGT2lAoy1HDmpFC/iijyEAOm5a1j2Vtr57N3ngQiDQSD3m8T8wTMQqwInMHmcRVa4GY17Aoon8I0hi2XkqCI+//N+HHtWuevACVqs5BbqXrBhVY77f7GO2XdvoimlSSiZj/n3mMgFGDu5rK1zhgBamwwrF6UdMGO7kQXwAVFusUcCjgE04qgoZTJHU6+GfyGK12p8BvSLceYVVUxu22Kl27dYhXBuOmmZ8cd6/n5bA0uXOBSvqAtg1K7WaNpATb8Y/feNttXJALQ2alYuyhBBdiPDCgE26ClsGQP83bscG1nBW4d2Pd65k2COFKS0Ju5JTr+kis9N68+AEdEtnLqOtXjz57Twx++tYdFrrQgExUE8vycRP7zGHIaB+0fp09+jowpYtiDNpmbfNYt0Mykc0mvHgBXeUub3UYj+bstGz9Z7ty3OyGrDMeNLueDf+3L0GWUI2UmLlS3U4i19M03dTet5/sFGmlNBixV7lrpvrwEEWW0YOipOUakM8ICCPzr77k09g0OAMGSRiKETmN/XU3jV4A8w+AQDnXoQxTNkrWX4fnHO+EYVp3+1ikSJ3KIEqy2ws3mD5vE/1PP32+pZvS5LMWp3iyZ6Jv43Fg/B/kcm2kUvQkKyUfP2cy1bbf/q2qNYGWxYGaDwqj2NrvaI9rNuC4fofklwbJjSmuJixVmfr+Rztf0pq1btiI1oD+Zo3/Lyo03c9R9rWP5+Gg9BWRAu7dHEp1CTMGRQnNGnluQ1Qqj+ly5Ik2w0PVZ3Z/GNINrPJ1ftgR2oiOOTM93pAIZATUY7fOuEsys4/7t9OexE12JltXORO6vFe/v5Vh761QZefKSJnLUurINuiZW759oFPobhoxMMGB7NS7/RFoFg+YI0yaTuYvx/m3iqVsSlT3agp7Cj3Gq17rP/MkDxctqy3wEJLrymL6d8tg9eVOThW9FJLV7Dhzke/X0D02+tZ1OzTwJJtBuKM7pd4gL1v9+RiQ4Ednd82YI0aQwlyusR59XtqdEo7CgPxH4u/u96AChssWrVPlUVEc75Zl/OurIq7wVvDcXzfcvMP23koZvrWfZuCm8HWqz2aAawEFWC4YfHg3yGyCeoks2a999I5zcW9tCJhKO52M+zUB6kI7pc3ae0ociTnHlpFWd9o5oDji4qELuTWjyAVx9rZvpt9bw8owkL+R56o/dCylOo/ystVexzSKKdUyiUYNmCNIvmtpIQEm165hpFgDZaKPcElAY7+LpEA4gA7sxq11H7pesHcOw5ZXmJF1JskbRRnmDd0iwP/noDj/6ugYw1xKVE7MFh3c48NDB4ZJz+w9rU/wUGd/EraZozmnLP65KC0x3XABaB27bZx3YRCBRyeywu+XJtfyZ9tZLSPiqYhEmhFq9Ni1UmyNY9/ueNfLgyTSIM6yx7pbrvzP/J+Jpjzi4L8H8nBDLoDFrwbAuRoCGkR80SBpB9PIut6Ir0gxAOS4xEBd+6czATPt+nnZSHttAY13xhLbz4SBN/u2kDr/6rOWil9nq0OKMn4n+jLXEhGfWp4vw9EEH411zvs2JRGmV7K/lmijwB8bYe6e6EOhnjc+ZXapjw+T7oXJukTZsiTBXU4j1w4wbm3LvJ5cfDpI22fJQeIco5eFiMfkH5N0LkE0AbVuaoX5nrpb47i4Uiz0JpkAcQu3OhvjFUlkY49XOVQZ19m7qioEqneaPm4Vs28PidG1m1PkOpUC6s03wkH0IINIbBI2NUDvDy9yo0A+++kqS5RRMRoofNnRAWg4DKLgN+DFA50DU6hGhfeFGtmzXPPdTIX29Yz9L300QRlHtevjij0wK0/P7uvZkF3OGHHBQjGpf5wlQbCMUbs1vIYYlK4YCwnj+d9QQ0C2TMYnarFcACkbggEhV5g2KC5E3LZs3rs1qQnqC6zKO12ZDz3d5v0wmRRbCTWyHyeHmeocJVzbbgV+yp6t8YiCvJyKOK8vfIBM7wpnU+S99049964Rqsc0N1s2chLfLH23U/QADJzYZ0q6G0UuUHHVkL/YdF+eH9Q2lt1CSbDE31PpvX+2xam2Pzes2mdTka12s2rs3RuMGnuV6TbHZ/26J9fG2RCFT+q8AkUobops0PdNhTNIdvLVWVEUafXJIHuax2Ax/ffSXJmg8yROmNIjwb/pv2BHITiMG7+5YKqF+dZfmCtJuK3abRMpSIkgpFSYWiZmhkm+/VWK9Z+0GG1UuyrPkgQ/1Kn8Z6n6YN7rllsybdYki3GFLGoHEMIiH/HCJrYSWxaCuageqw3RlqBmHeiDFx+vT3nPcvCsvuV72bIaV1ULjSOyGKQGz2LLTuLgpoLSglac1pHrm9njETSoJkR/spGx0YsL36aPMor1aUVxflkcPwkWoxTits1rQ2alo3+rQ0ahpW+6xbmnUMsyTDpg0+ftri59yIN23tFh+rEESFyMPV3UB/DJYjJoY4WwEXCBnAFGChXiC/xOJv8iwmLfB2+wjGWBJC8uJjTdwzdR2f/1n/PPE70T5bEL9tJiqUTGts3jJJJUiUSBIlkqqB3lYZUfuWlkZN/fIc65ZlWbciS8OHPi0bfVo2O+Zp2eS+1i7P4FtLTMgu1wTGQJGnGH54Ik/j0MgmmzSLX0kSQfaSExMiEWQ8gazHNYPuHhYcXIcnBP/3i3WsXJThoh/2ZZ9RCaIxV/m6LbjB6EKiJ2QGKdufyLaRJNuBh8LqIi8iqKj2qKj22C8ovmhnl3OWdKulucFnxTtp7q1dx9uvtnYpE4igNb16QIT+w9rU/4Xj35bneP/tVIAA9g4CIJAY2OiBXhJYTbv7bxxAvgiefHgTb8xuZtDIGJUDIlT086ga6FE9KELV4AiV/SOUVSmKyhUlfVReNW5VonTBUQ2JLbYV34TPAVWFEHkGKakQlFREGTAiSr99ovz4jKWsWZl14VgXEEQIQRbDvgfHqR60pb/z6j+byWlLXIpeimKEBYVEvOsJ5DuiG4qRipWitVmz6LVkYAILdtgGTmNlnwgDRkQZuF+MfvtGqKhxTFFa7VFaqSjt45ijpI/Ci4jtRin5KKBtGCDEFuYlPEgua9j3kDgTv1jJH2vXOC3QRbC4j2Xk0QkiMbf8SSnyyyNem9nco8nfTvwT64Se9z2LWa5JA6FB6pq6EKMtSriQzV2raGcBLNC0SbNxbivz5ragsXhIYghiMUksIUmUOpufKFUUl0tq9oky+IAY+x4cY+DIGOXVEZQHkZhEeR09frHFebRps6FLQCTq1P6xZ5cx/bcbaG7UqN1E5YRw84UrYh4HjSsOTmKx1jFiw+oca5dl3O3vFel3k4g0aXzEMk9g11ty6wSRfpac7eqP6miw23niAjwhSQS23hrn+OUylkzGp3GzQxhtmLsKwjyFwJNQ3EdROcCjelCUygEeFf08Sis9yqsVpVUe5X09yms8Kvt7JEpkwSkNbHEIMA0fnWD0qSU8+dBmErvZHOfwf8Ow/Yo4aFxR4BOIvGitWpyhaZ3u1dk7Ak9asus9Ihs8jaxXiDUSr5+Pb3pyLlA+Djftx6dL4QidjxCC79uqeG2gscFnU4PP4gWpPKPkASIgEVX06R+haqDnfI5qxehTS/n0lHK36qJNqfmU7/fjxUebMNlCW/lu+MIMPTTmlkgE7d/GdwDQ8gVpmpKamOyuBtDtnU8Yhac02VUe6fVeBYsbGjngwwiR0cINhex1+NxuTZNs4fk7ExMNvcI2L7BALmtZsyLDyhVu5YrG8mxdI0NHxRh2SDxow3Yv2f+IOMdOLuephzdRpJRD7Hbx/BLB8EMTW0QG1sKS11NkcH0M2vSG9GMlUXKkVj7K2AZZx0VawNw9DVIPb1g4OaNTz8QWagyMtoWvcDefgIh0QyDKPI/KaITNjTmef6ixXVgW1iYed0EZMbV7xRnWOhU64shC+ZdLhQvWL88y/8kWEqhekf72YaCYD/mNk+bVHM05t/6t99MrQgZdwTFBUbFsh+btlCYJysuNtmjfonPORMz880aaGnTerIQ1+sedU86IgxNkrNluWLotE5AoUvmZw23twvtvpFm2Mu1mC/dK0Yu1AuEFtH458PwhQfYlsBv3hImwUroRbyecV07to8O4fvZwvvzzARSVqh2uWhCyUHLWzjIAUSFZvSLDrLs3Brbe5usYEyWSs77d12XodkFCpYIMhrGnl1JWrfLtX2G6e8nrqT1gAIMH2I1xUiEDTJXTOaZBIBZKl2frtfNJBUljGH92BdfcM5Qxp5Zw4LFFXHJtDed+p5oUBrUdyXT7fQwZY0gag24788SCkC6ieP5vjSSbjRvFYtygZoDjzi1j3wPi+NidDoiFEBgsR08uRamAiQLz5ecs789L4Vm5m9M/dw8AkigEYuF0jmmAqflqPSEQcwruUy8cLWifGjQ4yjduG+gGKGvQOYvRcORpZSRwc307JYzzbshZw6HHFHPx1TWMP6uCeIloV/JqjCs1f+vFVha90JrXAmEYWlalOP7CclLW5Ac37nD871v6FHkMChZHtlX/rU2G5QtTvRj/58E462jt8pJyarBq1GLm0EujQWSAnJVXelz7132pGRrNo2fhRq7mjT4+TmI7I76UkDOGM79Sza+eHsHlvx7ItEf25ao/DIG2piCY0qWt5a/XryebbtOcElDm5Ev7MKh/lIwx+e1d278I8DH0HRql75BonitC5lu5MEP9Ch9Fr3tZwpB9GoSdyjRkbcCPPqVvadKLFFFpu71DvT3xTOCRf25qP0YdV+RQRFVw0LJpy+P/tTHwAbbsDpICWrTh6FPKuOLWQUTibvy60TD+kgqOnVzqJDo/ItYSRfLWs60seLa10IsoXQp7yEExxk/pg2/tDg9sEQhyWPoPi1I9OJKf/xOGky//o4mkr936l96RfqOISk16URr1FkCtU5rCwgNqNiMawUz3KEb04LSI0GZPubqGc75dHTSFFtrFhID7/nMdLzzeSELILYonpBKkjWHEiDhX3DqIaDA1LCxGkQL6D49tYdOlhAyW5x7c3Cnwc9z55RQrhb+DPdM2iP+HHZZwQ6qCCeVSCbRveefl1m7uwNy+nHkUA2b6M4zZDA8o5xMA4+kboPVido6WVKFHt7udPke8Y08p47O1/drZRu27Uzz3YCP/98t1dOb7CQHaWIpKFVf9cQhDR8XQwez/cPb+2qVZnn+40fkPHTx7ZeG5hxpZ+mYaoZy0hld+8PFFHHJCMTnMdmnmzmEojSmOObssYLDC9M+1y7KsW5YlQm85gK4TMUdzSiBmt6W5BHiGEzVYUUP5C4bMO4qEsDu4fHh3wr2MNow4KMHVdw/JD4ZwUzNBefDBvBS3XrEKa9hyd54IzYfly7UDOOzEYrTv5gmGf6d9y1+uXcOqlWm8DqleayDmSVZvzDLjjw0ONwgobS14nuCLv+xPNLJjRkDjah9HHVeUD0XDg6xclGHTGh+P3okBHfybEIbc2yUsfs6NBz5R5xnAbZJA/oVhaYl8zKIRdF+7imshg1hU8o1bBlE9OJJvFwuZYNNan5u+sJKG+hyRQJo6MlCrMZzx5SrO/W51oPYL4I8QcP/P1jPr/k0klOrUqwmrmF59rJlN6/y8KQhnN+x7aIIxny4lbbYNDLmuKMuB44ocwGjbcqlbANWc0+2Ys2fVv5GOpmpGHRdlpzi32LZhAKgL7L7B/p8h43fbvOCgMNJYyxW/HcSYCSX52sGQeL5v+cO/r2bR/KQb7mg6AYu04egTSvni9QPygEtB2cFzDzVx38/XoZBblTprICIEy99P88L0xrC4uDDSNS4Yd145TpjtNtE/CYwcW1T4RXAOrWHxK6leBn+kMGR8D+5tS+t2DOA4woonGPO2hYc8irEdt9V3ieoXpIxm0hcqmXx5ZdAx3CaRouC+2nXMuG8jRWpLuy2kW+Q8eGiMq+4akt/vJ2ShD3HJ6ynu+NYqcr5Fie1PABfA9Jvrad2s8zkCt8LdcuJnKhh5SBEZYzvflx68f9yTDB0V7xj+01zvM+/JFuKIXU8w7Zb6R3uUALbuUQ57ZweWRgF4d2gyObFbidGtIH1aM+6Ucr7224EBZBsMSg5MwHMPNVL36w3EwsFPdktVW1QiueLWQQwaGQ3CN/LPzRs1t39jFWvXZInsQMmV0wKSlUsyPPe3xvy+AHflgrIqxYQvVnZQ7VtiGDX7RBk0skP9H/De6ynq63Ou0KR3sH+hSacl6vb2NO6EAdxCISueYNRzhuwMj2JJhz1zu5Xg0ZZBg6J87ZZBFJerwqzcAPRZtiDNbVeuIpUyWyJmwt3tjLF89RcDGXdOmUvutGk+9bOWP/9gLW+83Eqxp3Y44SKlIGMML/ytMXhP0a5lbdy5ZVRVR9Cd9M4IKUhjOPj4EqoGRrZgkteeaHYC1yvRn9AexVKTnfUYh7zoNsO0XxolO2LFoYMgUHdqUj5dUCASzg1IlEiu/vNQ9j04hvYLHr+Q0NSguelzK2lY5xPrpDhTSac9zvlSNad/vTIf64PTHsqDh2+uZ/pdGyiWstNhC50liEJnsEhJXprdxFv/as1v9QwbOfvtG2H8ZypI0gHIaTP+7cBjgxnGAVQtJOQyhg/mpRC91v6N0qR8ibqzLW23wQDgNktaMYOHZhj8VxRxsdt7NAKv/7PX9uOIwOlTXkHCrYE7v/Mhb77RQkyKTp2+Fq05YlwJl988EC8i8vV/rgPJmY57atcSlbKTXsPCWplMMGeoHRMEAprJWP5+Sz1+rv1MAykFp3+1kv7VUbLG5DWDwL1ndXmEEWPieWYP71bDas26ZVkn/D3f/mVcOO8/N4OHZjjp31Kbb8XTnyag1gjET8Is+q5eQui0Tf5CFVO+X9N+AKRxKvzBm9Yz896NlHpep+Fe1loGDo5x5R2DKCorJITCQouV72T4/Xc+JJnSWzRbhn6DtpaagRGGDIshYIv6AqMhjmT+ky28/0YqX08ggtBt30PiHHVaGTlbGPAolYOxq4Z4DA4WQLjsonvv5W+naFjtu5rrHvf9JBY/I+CnUGscTTtNYXT2qLVTeEDN4LCnNJn7IpTsUn4gLOwYNCTKJdfV5OP88IZLJXjlH838Zepa5yR1mOWfxwtigu/8bjAjxiTyrwvj9cYGzc1fWcnaD7OB42jbvx5LNCb52q8H8qtnRvDLOcP57p+HUFyuMB3gYSUFm1p9nvnrpqCSp8D6QsCpX+hDkadI5jTaWNK+JWcNnzq/gpI+hWgkPMHiV1M05ny8Ho7/LcZEKJGa7F8eZ/RTU7DKMcEOMwB2FFOCJJH4haZ1vSSy031MUgoyGA44poiBI1yGL++xK9cf97urPiSbsZ0ifTYg4Ge+349jzipzr2+DF1jgnuvW8sbzLcQ7q7KRgpy1XPC9Gs6/ui8D94tRs0+UCV/ow/lX9SWL7ZBddGHjvx5oZPWSLDLwRULGPWJCCVfcNpB9hsepqPIYPCzGv13Vj0uurSk4/9b5JqlWw/ynWnqj+tdIojJL81qBfyNYMWob2nurYE8twkyhTj7J6MVgbpRExM7u2rDWEbZ+VY5s2qAU5ALPvXmj5tdfWsnyD9JEVSdIX5AkGn9+ORf/qMb5DW2niynn9D1yVz0JteWE7TDkPP2yKi6rda832hVmGG0ZMSZOsXKj2UIeMAZiQrFyVYY5/7upUCtAwWc48+tV3Pj0CH72xHBunDOCr908kEhMhKt/8pXOC59PsuClFoqE6tGJphaLJCLA/moGY9+fQp2s3Qasv020r46LDEyVlqLbfZJzPYrkzjiExji7+u6rSf5+awO5jCUSdcMRfn/Vh7z5QgtFcssMX364gic5+dLKoCvIBk6fCxlffbyZu69b46Aq0143OaTQMvroYr50Q3+kKNhsETSG1K/0HcTbwWe01hIRgtn/u4nN63zX5dwhh9B3SIT9j0xQs0+kfT9jm+9n/KGBrN+z4Z/bE1wkfZJzBUV3wFTpaLgNLb2995zCwWIGIzMC8QOLTQm8HZ/XGXr5Gu78/mqmnb2MP/9wLd8/6X0ev2djAezZGrwqBF60bWFnYDoWZ7jt6x+STJktwB5XGGKpqYlw1Z+GUDUw4lKzgXeulGDV4gx/u2VDUBTTPkFjLURx8PCtX19FJmmC9C7tklVG23zOwQ24Ij8UY+Z/b+TZhze7VrMeS6xbKx1tWhX2mhmMzEzh4O32nm/XRC2kzk7hAfUIp7w/nC+XKIpPMGR3erWcJwVLl6R59bkmWuq3vxdPSUFSa/pUehx9Rll+4liyyXD9Z1bwzptJpz1MZzwnuOYvQzjsxJIgN1BYzZ5JWm66bAVvzW3d6hksEFGCxYtStNb7HHFqWX70jdE26DcUwRYT93M4zn7OfZv5zVdWOj+nR71/oSMUeZrWXz/OmD9N4QFVx0XbBfF29ITCwYgLIk3oxyMUnZyjxYjO0fFtQMEiWASx/ZgiBGOiccG533FTxTMpw5P/s4lnp28mqmT7wUpB8UfKGL48dQCXTutXGFARIIXWWu66eg11t613TuN2bo9QLul07CllXPzDGg4/uWSrtQFL56d57K4G/nFHQ1619tjcz8Drz5F8qgx1eh0H59jB0H2HWXQqU2UttWYSb40QyDnAYEPOdveSSYtbtRKXzmHL4gYvdjRCyoNW33DCGRX84P6hxBIin2cIGeGxOxu4+YqVeKHh3wEKCQEZayiOKQ4ZX8yYU0oZdniC0j6SVLNb9LTgX63Mf6qV9fVZYsguzqBs3+47p49VEn3iPznsg6nYbTp+u8QATgM4tTKJN84TRP7mqu6M7O46JyHbTxPvND1sDAePLab2H8OobDuTJwjjXnuimZ9dspxko9npwsww05hEu8nlUdeurrUllTakMSSQrm6hRxs+rAVpBEoZchc8wei/7ajq3yUGKETnwkxi3k89Sq/L0bTTpmBX8wl0QjghBb41VNR4THt4GKPGFeUlPmz52rAyx1XHvsfa1blA9dtd+nwZtI0ZE1YQC1Sb39se7vaxWB2hVGVp/NlMjvhxocZzx62P3HmNLMxUrDyGw6dmafpLhDJJDywc7Gyil+uycXMIvnXb4ID4hbo+BKRbDb/50kpHfCl2eRxtOH/INZHgZh+I9r/v4YcfoUxlabx7JmN+MtURf6cX4u6S5E4DW4uwLbR+y6flCUWx1xsjnoWEtDFc8oMaPj2lPF/anUfDpeCeH6/lhdlNxFXXqef8EKvea/DQHkWeT/M/LfKbIU125b12iQEEwk5lqniB45tBX+bTMtejSNoeHHjqkD7DCWdWcNlP++clHkE+1Tzzvzfy0B31bhbfR2QCeUB85dP6WpzI52cxunUq04TYxZa+3XLeQm/zNF7bTxGZJYnv65PUIr8BqJuIH0j+iFEJpj0yjIEjogXMPnhe8K9WfnL2Ulo2azwhPhK7BxzxE0qTWWqQp83kkCU74/F3mQZomy8YzxxvJkcuMdgLDLkPFHHVnZogzMFXVkX47h8HM3BENF9XGBJ/9ZIst319FU2b9Q6Vhe0lD98joQzZpQr/vJkcsmQKVtXuZvl+F4VvzgE5nXkjLd6DHrFDfVI+2K7vN5eQw/If/zWUSV/p066iGJz6/89zl/LsY5sp6aY17L1D/GIvR+oNTcvFsxn3HgWnb3dvZ5fIpRnPHO9xRi/O0HhWjuQzHkVeV2sCqQQpYzjlwj6c9qU++YISCKQf+J8freGFx5ooVqrH17B0i9LHao9iz6flX5rMubMZ99545nh0UeNOl8Xvz3CSP4UH1Bw+tTyNOden9W9RypRFaEtXUsIy4oh40HhZ6L2XCubcu5n7frXeATJ67945ZN1aCROhVOVoeTCGPXs2Y1dM4QH1DCd1WdjdDQieU02XMzeyktjtkvjlDivTZndhY+UJmn3NmZdW8b3/HeJ0ow+eB4teSjLt3KVs3qBRdu8nvsSTihiG1B2Pcei3gr4NSRe37HUThFs46ERe/4ogeoNHrCpHqxbtu/V36bQyAhdfU8MF/1FDcblk/lMt/PbyVSx7Px2MX99bqW+tBROhRPmk12myP5rFEX/qeE/3AgaAQrJdmAnMO0ShblHET9aksOjdgo/DmYCDR8RIlEo+fDdLa0q7/UN2b5V6YwRKKoowpGanSX1zDke/C1MlTLPdNbqn2xPW45njPcNJ/njmeAn6/EgQuVYRjeZoDWY+7bxZCPVHxrqVM1EkStIbcGyXqHuAiGvgSBr0DWkarg/vWVfa+15hgI7qaxLzjpdEagXeyW5rUDZsPtnpswhZKMTc+2y+tSC0JOoJJBr/KUj9aAZjX+pOld9tUcD2wkRAuFLz0c+1sn6iJvsNQ26ZR6lXkISdI6M15IdC7l123qWUIpR6htxyTfYbKdZPnMHYl1wJd/6edT9levry2+arJzF/sEBeYzBXehRJQwqL9cGqXpul0s0SD8LzSOCT9MHeYVC/nsmhKzvem5569NpN7sAIxwrE90BOViTiPi1YbLfnFHrQzmuBUB4laFJpMI/5mBtnMfrl3iJ8rzMAhMmkaYRdK5N4c7zFfBPEeRGKlU9rMKPABgtC9hatYG2wEtMKUB7F5GjVYB8WyNtncNgz4fWDy6n01kn3iBu6JSPMO17ifdOgL/IoEhaLJmlxXQB7sHmw+TMqioRA4JO0EvWAwb99BqOfC65YTgVqt9Ku9bFjgK0xwum88SmL/LZAHgwc7FGKTwsG35BfumI72TvWY8TGDdl0il7iSY8SfJqx8DaYtwXm1scZ83yB8NN6VeL3aAYIAaQp1Mm2NnESL5VZ4qdKvFMs/nmK4gHh9BoXSvqA9d3PYTe47UKTYa0Nau0KbSTCk3jBegoAhaZ1jSDysCH35CbSs1/h2Kb2Ps8U05uzmPcSBmjPDON5ul3yYyJzBwhih1r0yQJOADXcoqujlCkQGLJY/IAp8G0Bkeww+awjcxSCSUfs/FxdC3gCD4mHJApYsjRpgaoH84FAPGsRT1kybz3B2DXtQbAT9Z5G9L2IAToywtOmY5vzBObVSMSxAnsUiEOAwRYGCOzACGXC7QkxwdYhG1TzhnvMwt2dkrCeTOSfZfClyNFkQawG1gCrQCyw2FdziJef4rB1HQyZHM+Jck8n/F7GAO1vsLOj04Kf2zPEmcytzhGpkphqEP017C9guIAaoBwos8EzUBW8rAFoEtAINAGNFtZb+EDBe2DXalRDlGz9o4yt73ge57+EZ6rdqwDp/wcBg24wkw644QAAAABJRU5ErkJggg==",
    },
    {
      author: "master_agentemotor",
      subject: "",
      create_date: "2023-04-05 08:34:35",
      message:
        '{          "name": "message-policy",          "insurer": "BOLIVAR",          "interface": "BOLNET",          "status": "Fallas tecnicas internas",          "message": "Error al ejecutar el test:",          "url": "https://agm-storage.s3.us-east-2.amazonaws.com/screenshots/8f94d4ad-67ae-4ab0-87d0-9d98f0e83aa4.png",          "data": "❌ BOLIVAR - BOLNET - Fallas tecnicas internas :: Error al ejecutar el test: https://agm-storage.s3.us-east-2.amazonaws.com/screenshots/8f94d4ad-67ae-4ab0-87d0-9d98f0e83aa4.png"      }',
      avatar:
        "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",
    },
  ],
};

export { response, messageResponse };
